export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never
      }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string }
    String: { input: string; output: string }
    Boolean: { input: boolean; output: boolean }
    Int: { input: number; output: number }
    Float: { input: number; output: number }
    Currency: { input: any; output: any }
    Date: { input: any; output: any }
    DateTime: { input: any; output: any }
    ISO8601DateTime: { input: any; output: any }
    Upload: { input: any; output: any }
}

/** Properties for accepting terms */
export type AcceptTermsInput = {
    accepted: Scalars['Boolean']['input']
}

export type AcceptTermsPayload = {
    __typename?: 'AcceptTermsPayload'
    user?: Maybe<IntermediaryUser>
}

export type AggregationBucket = {
    __typename?: 'AggregationBucket'
    count: Scalars['String']['output']
    key: Scalars['String']['output']
    label: Scalars['String']['output']
}

export type AnnuityTerm = {
    __typename?: 'AnnuityTerm'
    date: Scalars['String']['output']
    humanDate: Scalars['String']['output']
    humanInstallment: Scalars['String']['output']
    humanInterest: Scalars['String']['output']
    humanOutstanding: Scalars['String']['output']
    humanPrincipal: Scalars['String']['output']
    /** The amount the customer pays */
    installment: Scalars['Float']['output']
    /** Part of the installment */
    interest: Scalars['Float']['output']
    /** Only present on lease terms, not VAT financing terms */
    invoiced?: Maybe<Scalars['Boolean']['output']>
    /** The outstanding after payment */
    outstanding: Scalars['Float']['output']
    /** The installment without interest */
    principal: Scalars['Float']['output']
    t: Scalars['Int']['output']
}

/** An attachment */
export type Attachment = {
    __typename?: 'Attachment'
    canCreate: Scalars['Boolean']['output']
    canDestroy: Scalars['Boolean']['output']
    canDownload: Scalars['Boolean']['output']
    canUpload: Scalars['Boolean']['output']
    createdAt?: Maybe<Scalars['DateTime']['output']>
    customerHint?: Maybe<Scalars['String']['output']>
    fileName?: Maybe<Scalars['String']['output']>
    fileNames?: Maybe<Array<Scalars['String']['output']>>
    hint?: Maybe<Scalars['String']['output']>
    id?: Maybe<Scalars['ID']['output']>
    label: Scalars['String']['output']
    name: Scalars['String']['output']
    ownerId: Scalars['ID']['output']
    ownerType: Scalars['String']['output']
    providedBefore?: Maybe<DealStatesEnum>
    requestedFrom?: Maybe<DealStatesEnum>
    state: Scalars['String']['output']
    subjectId?: Maybe<Scalars['ID']['output']>
    subjectType?: Maybe<Scalars['String']['output']>
    supportedContentTypes: Array<Scalars['String']['output']>
    supportedExtensions: Array<Scalars['String']['output']>
    token: Scalars['String']['output']
    type: AttachmentTypeEnum
    updatedAt?: Maybe<Scalars['DateTime']['output']>
    uploadedAt?: Maybe<Scalars['DateTime']['output']>
    url?: Maybe<Scalars['String']['output']>
    urls?: Maybe<Array<Scalars['String']['output']>>
}

/** Valid states for an attachment */
export enum AttachmentStateTypeEnum {
    Approved = 'approved',
    AwaitingApproval = 'awaiting_approval',
    ConditionallyApproved = 'conditionally_approved',
    Disapproved = 'disapproved',
    NotNecessary = 'not_necessary',
    Novel = 'novel',
    PostponedApproved = 'postponed_approved',
}

/** Valid attachment topic types */
export enum AttachmentTopicTypeEnum {
    Deal = 'Deal',
    Lease = 'Lease',
    Party = 'Party',
}

/** Valid types */
export enum AttachmentTypeEnum {
    AnnuitySchedule = 'AnnuitySchedule',
    Appraisal = 'Appraisal',
    BankStatement = 'BankStatement',
    BankTransaction = 'BankTransaction',
    BkrCheck = 'BkrCheck',
    BkrPostalCodeCheck = 'BkrPostalCodeCheck',
    ChangeInterestPercentageAnnouncement = 'ChangeInterestPercentageAnnouncement',
    ChangePurchasePriceAnnouncement = 'ChangePurchasePriceAnnouncement',
    ChangePurchasePriceWhileActiveAnnouncement = 'ChangePurchasePriceWhileActiveAnnouncement',
    CocExtract = 'CocExtract',
    CollectionAuthorization = 'CollectionAuthorization',
    Contract = 'Contract',
    ContractBeeport = 'ContractBeeport',
    ContractTransferOrPurchaseAgreement = 'ContractTransferOrPurchaseAgreement',
    CreditEstimateReport = 'CreditEstimateReport',
    Custom = 'Custom',
    DeliveryConfirmationTradeInToVendor = 'DeliveryConfirmationTradeInToVendor',
    DowJones = 'DowJones',
    DrivingLicence = 'DrivingLicence',
    EarlyBuyoutConsent = 'EarlyBuyoutConsent',
    EarlyBuyoutProposal = 'EarlyBuyoutProposal',
    EuroPermit = 'EuroPermit',
    Financials = 'Financials',
    Fundflow = 'Fundflow',
    GeneralLienWaver = 'GeneralLienWaver',
    GoogleMaps = 'GoogleMaps',
    GoogleSearch = 'GoogleSearch',
    GoogleStreetview = 'GoogleStreetview',
    Identification = 'Identification',
    Indication = 'Indication',
    IndicationBeedirect = 'IndicationBeedirect',
    Insurance = 'Insurance',
    Invoice = 'Invoice',
    KvoContractTransferAnnouncement = 'KvoContractTransferAnnouncement',
    KvoOriginalContract = 'KvoOriginalContract',
    LienWaverForm = 'LienWaverForm',
    OperationalLeaseRulingDecision = 'OperationalLeaseRulingDecision',
    OriginalInvoice = 'OriginalInvoice',
    PackingSlip = 'PackingSlip',
    PaymentConfirmation = 'PaymentConfirmation',
    PaymentConfirmationDownPaymentToVendor = 'PaymentConfirmationDownPaymentToVendor',
    PaymentGroupOverview = 'PaymentGroupOverview',
    PaymentOverview = 'PaymentOverview',
    PictureCertification = 'PictureCertification',
    PictureExterior = 'PictureExterior',
    PictureIdentification = 'PictureIdentification',
    PictureTotalUsage = 'PictureTotalUsage',
    PredefinedCustomAttachment = 'PredefinedCustomAttachment',
    PreviousContract = 'PreviousContract',
    PreviousIndication = 'PreviousIndication',
    PreviousSignedContract = 'PreviousSignedContract',
    ProofOfDelivery = 'ProofOfDelivery',
    RecoveryIntakeForm = 'RecoveryIntakeForm',
    Registration = 'Registration',
    RegistrationPrerequisite = 'RegistrationPrerequisite',
    RemarketingPicture = 'RemarketingPicture',
    RentalContract = 'RentalContract',
    SalesNotice = 'SalesNotice',
    SignedContract = 'SignedContract',
    SignedPurchaseAgreement = 'SignedPurchaseAgreement',
    SignedReciprocalGuarantorsForm = 'SignedReciprocalGuarantorsForm',
    SignedRemarketingSaleContract = 'SignedRemarketingSaleContract',
    SignedSuretyForm = 'SignedSuretyForm',
    SignedUboStatementForm = 'SignedUboStatementForm',
    SpecificLienWaver = 'SpecificLienWaver',
    Statutes = 'Statutes',
    SuretiesForm = 'SuretiesForm',
    SuretiesFormExplanation = 'SuretiesFormExplanation',
    ThirdPartyClauseInstructions = 'ThirdPartyClauseInstructions',
    TrackAndTrace = 'TrackAndTrace',
    TwikeyAuthorization = 'TwikeyAuthorization',
    UboRegisterExcerpt = 'UboRegisterExcerpt',
    UboStatementForm = 'UboStatementForm',
    VatAnnuitySchedule = 'VatAnnuitySchedule',
    VatNumberCheck = 'VatNumberCheck',
    VendorQuote = 'VendorQuote',
    VisCheck = 'VisCheck',
    YearlyOverview = 'YearlyOverview',
}

/** Error on attribute */
export type AttributeError = {
    __typename?: 'AttributeError'
    attribute: Scalars['String']['output']
    message: Scalars['String']['output']
    path?: Maybe<Scalars['String']['output']>
}

export type AuthenticateInput = {
    code: Scalars['String']['input']
    dealToken?: InputMaybe<Scalars['String']['input']>
    organizationToken?: InputMaybe<Scalars['String']['input']>
    persistenceType?: InputMaybe<GraphqlAuthenticationPersistenceTypeEnum>
}

export type AuthenticationSuccess = {
    __typename?: 'AuthenticationSuccess'
    /** Expiration time of the session cookie */
    expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>
    /** Indicates what type is used to persist the authentication of the user */
    persistenceType: GraphqlAuthenticationPersistenceTypeEnum
    /** Use this scope to notify about the persisted authentication in the cookies by passing it the X-Session-Scope header */
    sessionScope?: Maybe<GraphqlAuthenticationSessionScopeEnum>
    /** Use this JWT to persist the authentication by passing it the Authorization header */
    token?: Maybe<Scalars['String']['output']>
    user: UserUnion
}

/** Response for authentication request */
export type AuthenticationUnion =
    | AuthenticationSuccess
    | DealAlreadyClaimed
    | IncorrectCredentials
    | InvalidDealToken
    | InvalidOrganizationToken
    | LoginCodeAlreadyUsed
    | LoginCodeExpired
    | LoginCodeNotFound
    | OrganizationAlreadyClaimed
    | SessionScopeNotFound
    | UserInactive
    | UserNotFound
    | UserUnconfirmed

/** Valid colors for auto-LGD traffic light */
export enum AutoLgdEnum {
    Green = 'green',
    Orange = 'orange',
    Red = 'red',
}

/** Valid colors for auto-PD traffic light */
export enum AutoPdEnum {
    Green = 'green',
    Orange = 'orange',
    Red = 'red',
}

/** Valid colors for auto-soft-KYC traffic light */
export enum AutoSoftKycEnum {
    Blue = 'blue',
    Green = 'green',
    Orange = 'orange',
    Red = 'red',
}

export type BankConsentProviderError = {
    __typename?: 'BankConsentProviderError'
    error: Scalars['String']['output']
}

export type BankConsentSuccess = {
    __typename?: 'BankConsentSuccess'
    bankTransactionDossier: BankTransactionDossier
}

export type BankCreditAnalysisDossier = {
    __typename?: 'BankCreditAnalysisDossier'
    id: Scalars['ID']['output']
    state: BankCreditAnalysisDossierStateEnum
    token: Scalars['String']['output']
    url?: Maybe<Scalars['String']['output']>
}

/** Possible states for BankCreditAnalysisDossiers */
export enum BankCreditAnalysisDossierStateEnum {
    Closed = 'closed',
    Completed = 'completed',
    Error = 'error',
    Initial = 'initial',
    NotShared = 'not_shared',
    Open = 'open',
}

/** Valid colours for bank credit analysis requirement traffic light */
export enum BankCreditAnalysisRequirementTrafficLightEnum {
    Green = 'green',
    Orange = 'orange',
    Red = 'red',
}

/** Bank transaction account details */
export type BankTransactionAccount = {
    __typename?: 'BankTransactionAccount'
    bankAccountNumber: Scalars['String']['output']
    bankHolderName: Scalars['String']['output']
    id: Scalars['ID']['output']
}

/** Bank transaction dossier details */
export type BankTransactionDossier = {
    __typename?: 'BankTransactionDossier'
    bankBic?: Maybe<Scalars['String']['output']>
    bankName?: Maybe<Scalars['String']['output']>
    bankTransactionAccounts?: Maybe<Array<BankTransactionAccount>>
    consentExpiresAt?: Maybe<Scalars['DateTime']['output']>
    consentGrantedAt?: Maybe<Scalars['DateTime']['output']>
    consentId: Scalars['String']['output']
    consentType?: Maybe<BankTransactionDossierConsentTypeEnum>
    consentUrl?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    specifiedBankAccountNumber?: Maybe<Scalars['String']['output']>
    state: BankTransactionDossierStateEnum
    supportedBanks: Array<SupportedBank>
    token: Scalars['String']['output']
}

/** Valid consent types for bank transaction dossier */
export enum BankTransactionDossierConsentTypeEnum {
    ManualUpload = 'manual_upload',
    Psd2 = 'psd2',
}

/** Valid states for bank transaction dossier */
export enum BankTransactionDossierStateEnum {
    BankChosen = 'bank_chosen',
    Closed = 'closed',
    ConsentFailed = 'consent_failed',
    ConsentGranted = 'consent_granted',
    ConsentProcessing = 'consent_processing',
    ConsentRevoked = 'consent_revoked',
    Error = 'error',
    NewDossier = 'new_dossier',
}

/** Valid colours for bank transaction requirement traffic light */
export enum BankTransactionsRequirementTrafficLightEnum {
    Green = 'green',
    Orange = 'orange',
    Red = 'red',
}

/** Properties for (re)calculating a lease group */
export type CalculateLeaseGroupInput = {
    /** Amount that customer pays when transferring ownership of object, optional when using monthlyBudget */
    balloonPayment?: InputMaybe<Scalars['Currency']['input']>
    /** ID of the category to which the object belongs */
    categoryId?: InputMaybe<Scalars['ID']['input']>
    /** Specifies the fixed contribution the intermediary wants to make, to use intermediary contribution for this deal */
    customIntermediaryFixedContribution?: InputMaybe<
        Scalars['Currency']['input']
    >
    /** Specifies the target interest percentage the intermediary wants to use for this deal, when using intermediary contribution */
    customIntermediaryTargetInterestPercentage?: InputMaybe<
        Scalars['Float']['input']
    >
    /** ID of the deal, used to scope the leaseId as intermediary or customer user */
    dealId?: InputMaybe<Scalars['ID']['input']>
    /** Amount that customer pays up-front when the object is bought, optional when using monthlyBudget */
    downPayment?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies whether intermediary wants to receive a fee */
    intermediaryFeeEnabledByIntermediary?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies the desired fee as percentage of object for intermediary */
    intermediaryFeePercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Token of the intermediary, used to apply intermediary settings */
    intermediaryToken?: InputMaybe<Scalars['String']['input']>
    /** ID of the lease to (re)calculate, only required when using existing lease */
    leaseId?: InputMaybe<Scalars['ID']['input']>
    /** Amount that the object is wort, purchasePrice is used as default, can be overwritten with good reason */
    marketValue?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer is willing to pay per month for object, will be used to calculate purchasePrice */
    monthlyBudget?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies whether object is new or used */
    objectUsed?: InputMaybe<Scalars['Boolean']['input']>
    /** Construction date of the object */
    objectYear: Scalars['Int']['input']
    /** Specifies when the planned date when the lease will start */
    plannedStartOn?: InputMaybe<Scalars['Date']['input']>
    /** Amount that customer could pay to transfer ownership of object, only applicable with operational leases, optional when using monthlyBudget */
    purchaseOption?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the object will be bought for, optional when using monthlyBudget */
    purchasePrice?: InputMaybe<Scalars['Currency']['input']>
    /** Amount of objects */
    quantity: Scalars['Int']['input']
    /** Tenor of the lease in months, optional when using monthlyBudget */
    tenor?: InputMaybe<Scalars['Int']['input']>
    /** Token of the deal, used to scope the leaseId as anonymous user */
    token?: InputMaybe<Scalars['String']['input']>
    /** Specifies the type of financing, preferred argument over use operational or withSale arguments */
    typeOfFinance?: InputMaybe<TypeOfFinanceEnum>
    /** Specifies whether object will be rented out to others */
    withRentOut?: InputMaybe<Scalars['Boolean']['input']>
}

export type CalculateLeaseGroupPayload = {
    __typename?: 'CalculateLeaseGroupPayload'
    boundaries?: Maybe<LeaseBoundaries>
    calculation?: Maybe<LeaseGroupCalculation>
    errors?: Maybe<Array<AttributeError>>
    postCalculationBoundaries?: Maybe<PostCalculationBoundaries>
}

/**
 * This are the arguments to (re)calculate a lease.
 *
 * When (re)calculating for an existing lease you only need
 * to specify the arguments that change. When (re)calculating
 * a new lease you need to supply the lease components
 * these can be provided in several ways:
 *   1. By specifying individual components e.g. tenor, purchasePrice, downPayment, balloonPayment
 *   2. By specifying a monthlyBudget, we will calculate the components based on the given budget
 *   3. By specifying a monthlyBudget together with individual components, we will calculate the components based
 *      on the given budget where the given components are fixed
 *
 */
export type CalculateLeaseInput = {
    /** Amount that customer pays when transferring ownership of object, optional when using monthlyBudget */
    balloonPayment?: InputMaybe<Scalars['Currency']['input']>
    /** ID of the category to which the object belongs */
    categoryId?: InputMaybe<Scalars['ID']['input']>
    /** Specifies the fixed contribution the intermediary wants to make, to use intermediary contribution for this deal */
    customIntermediaryFixedContribution?: InputMaybe<
        Scalars['Currency']['input']
    >
    /** Specifies the target interest percentage the intermediary wants to use for this deal, when using intermediary contribution */
    customIntermediaryTargetInterestPercentage?: InputMaybe<
        Scalars['Float']['input']
    >
    /** ID of the deal, used to scope the leaseId as intermediary or customer user */
    dealId?: InputMaybe<Scalars['ID']['input']>
    /** Amount that customer pays up-front when the object is bought, optional when using monthlyBudget */
    downPayment?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies whether intermediary wants to receive a fee */
    intermediaryFeeEnabledByIntermediary?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies the desired fee as percentage of object for intermediary */
    intermediaryFeePercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Token of the intermediary, used to apply intermediary settings */
    intermediaryToken?: InputMaybe<Scalars['String']['input']>
    /** ID of the lease to (re)calculate, only required when using existing lease */
    leaseId?: InputMaybe<Scalars['ID']['input']>
    /** Amount that the object is wort, purchasePrice is used as default, can be overwritten with good reason */
    marketValue?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer is willing to pay per month for object, will be used to calculate purchasePrice */
    monthlyBudget?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies whether object is new or used */
    objectUsed?: InputMaybe<Scalars['Boolean']['input']>
    /** Construction date of the object */
    objectYear: Scalars['Int']['input']
    /** Specifies when the planned date when the lease will start */
    plannedStartOn?: InputMaybe<Scalars['Date']['input']>
    /** Amount that customer could pay to transfer ownership of object, only applicable with operational leases, optional when using monthlyBudget */
    purchaseOption?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the object will be bought for, optional when using monthlyBudget */
    purchasePrice?: InputMaybe<Scalars['Currency']['input']>
    /** Tenor of the lease in months, optional when using monthlyBudget */
    tenor?: InputMaybe<Scalars['Int']['input']>
    /** Token of the deal, used to scope the leaseId as anonymous user */
    token?: InputMaybe<Scalars['String']['input']>
    /** Specifies the type of financing, preferred argument over use operational or withSale arguments */
    typeOfFinance?: InputMaybe<TypeOfFinanceEnum>
    /** Specifies whether object will be rented out to others */
    withRentOut?: InputMaybe<Scalars['Boolean']['input']>
}

export type CalculateLeasePayload = {
    __typename?: 'CalculateLeasePayload'
    boundaries?: Maybe<LeaseBoundaries>
    calculation?: Maybe<LeaseCalculation>
    errors?: Maybe<Array<AttributeError>>
    monthlyBudgetSuggestions?: Maybe<Array<LeaseCalculation>>
    postCalculationBoundaries?: Maybe<PostCalculationBoundaries>
    suggestions?: Maybe<Array<LeaseCalculation>>
}

/** Properties for cancelling a deal */
export type CancelDealInput = {
    cancelReason: CancelDealReasonEnum
    comments?: InputMaybe<Scalars['String']['input']>
    dealId: Scalars['ID']['input']
}

export type CancelDealPayload = {
    __typename?: 'CancelDealPayload'
    deal?: Maybe<Deal>
}

/** Valid pre-defined reasons to cancel a deal */
export enum CancelDealReasonEnum {
    /** Voorwaarden */
    Conditions = 'conditions',
    /** Foutieve aanvraag */
    IncorrectRequest = 'incorrect_request',
    /** Aankoop gaat niet door */
    NoSale = 'no_sale',
    /** Anders */
    Other = 'other',
    /** Aanbetaling */
    Payment = 'payment',
    /** Prijs */
    Price = 'price',
    /** Zelf gefinancierd */
    SelfFinanced = 'self_financed',
    /** Snelheid */
    Speed = 'speed',
    /** Test */
    Test = 'test',
    /** Leverancier */
    Vendor = 'vendor',
}

/** A category */
export type Category = {
    __typename?: 'Category'
    axleConfigurationRequired: Scalars['Boolean']['output']
    categoryGroup: CategoryGroup
    createdAt: Scalars['DateTime']['output']
    defaultAxleConfigurations: Array<Scalars['String']['output']>
    defaultForCategoryGroup: Scalars['Boolean']['output']
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    supportedTypesOfFinance: Array<Scalars['String']['output']>
    updatedAt: Scalars['DateTime']['output']
    usageRequired: Scalars['Boolean']['output']
    usageUnit: Scalars['String']['output']
    vehiclePurchaseTaxApplicable: Scalars['Boolean']['output']
}

/** A category group containing categories */
export type CategoryGroup = {
    __typename?: 'CategoryGroup'
    categories: Array<Category>
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    updatedAt: Scalars['DateTime']['output']
}

export type CategorySuggestion = {
    __typename?: 'CategorySuggestion'
    categoryGroupId: Scalars['Int']['output']
    categoryGroupName: Scalars['String']['output']
    categoryId: Scalars['Int']['output']
    categoryName: Scalars['String']['output']
    certainty: Scalars['Int']['output']
}

/** Properties for getting category suggestions */
export type CategorySuggestionsInput = {
    includeInactiveCategories?: InputMaybe<Scalars['Boolean']['input']>
    objectBrand: Scalars['String']['input']
    objectType: Scalars['String']['input']
}

export type CategorySuggestionsPayload = {
    __typename?: 'CategorySuggestionsPayload'
    status: CategorySuggestionsStatusEnum
    suggestions: Array<CategorySuggestion>
}

/** Possible status type for the CategorySuggestions query */
export enum CategorySuggestionsStatusEnum {
    CategorySuggestionsCompleted = 'category_suggestions_completed',
    CategorySuggestionsFailed = 'category_suggestions_failed',
    ValidationFailed = 'validation_failed',
}

export type CloneLeaseGroupPayload = {
    __typename?: 'CloneLeaseGroupPayload'
    leaseGroup?: Maybe<Lease>
}

export type CloneLeasePayload = {
    __typename?: 'CloneLeasePayload'
    lease?: Maybe<Lease>
}

/** describes the state of the collection mandate for 1 organization */
export type CollectionMandate = {
    __typename?: 'CollectionMandate'
    humanLimit?: Maybe<Scalars['String']['output']>
    humanLimitState: Scalars['String']['output']
    humanRequiredLimit?: Maybe<Scalars['String']['output']>
    humanRequiredLimitWithMargin?: Maybe<Scalars['String']['output']>
    humanState: Scalars['String']['output']
    humanType: Scalars['String']['output']
    id?: Maybe<Scalars['ID']['output']>
    limit?: Maybe<Scalars['Float']['output']>
    limitState: CollectionMandateLimitStateEnum
    limitUnlimited: Scalars['Boolean']['output']
    mandateEditingUrl?: Maybe<Scalars['String']['output']>
    mandateSigningUrl?: Maybe<Scalars['String']['output']>
    mandateType: CollectionMandateTypeEnum
    requiredLimit?: Maybe<Scalars['Float']['output']>
    requiredLimitWithMargin?: Maybe<Scalars['Float']['output']>
    state: CollectionMandateStatusEnum
    supportedContentTypes: Array<Scalars['String']['output']>
    supportedExtensions: Array<Scalars['String']['output']>
    token?: Maybe<Scalars['String']['output']>
}

export type CollectionMandateAttachmentUploadSuccess = {
    __typename?: 'CollectionMandateAttachmentUploadSuccess'
    collectionMandate: CollectionMandate
}

/** Valid limit states for collection mandate */
export enum CollectionMandateLimitStateEnum {
    Insufficient = 'insufficient',
    Sufficient = 'sufficient',
}

/** Valid states for collection mandate */
export enum CollectionMandateStatusEnum {
    AwaitingCustomer = 'awaiting_customer',
    AwaitingCustomerExtraSignatures = 'awaiting_customer_extra_signatures',
    AwaitingCustomerPrintUpload = 'awaiting_customer_print_upload',
    Cancelled = 'cancelled',
    Expired = 'expired',
    Given = 'given',
    Pending = 'pending',
}

/** Valid types for collection mandate */
export enum CollectionMandateTypeEnum {
    External = 'external',
    Manual = 'manual',
    Twikey = 'twikey',
}

export type ConfirmSignatoryChoiceInput = {
    token: Scalars['String']['input']
}

export type ConfirmSignatoryChoicePayload = {
    __typename?: 'ConfirmSignatoryChoicePayload'
    signingDossier?: Maybe<SigningDossier>
}

export type Contact = {
    __typename?: 'Contact'
    contactType: Scalars['String']['output']
    contactable: ContactableUnion
    primary: Scalars['Boolean']['output']
    recievesInvoices: Scalars['Boolean']['output']
}

export type ContactFilterInput = {
    contactableType?: InputMaybe<ContactableTypesEnum>
    receivesInvoices?: InputMaybe<Scalars['Boolean']['input']>
}

export enum ContactOrderFieldEnum {
    Name = 'name',
}

export type ContactOrderInput = {
    direction: DealOrderDirectionEnum
    field: ContactOrderFieldEnum
}

export type ContactPerson = {
    __typename?: 'ContactPerson'
    email: Scalars['String']['output']
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    phone: Scalars['String']['output']
}

export enum ContactableTypesEnum {
    ContactPerson = 'ContactPerson',
    CustomerUser = 'CustomerUser',
}

export type ContactableUnion = ContactPerson | CustomerUser

export type Country = {
    __typename?: 'Country'
    code: CountryCodeEnum
    name: Scalars['String']['output']
}

export enum CountryCodeEnum {
    Ad = 'AD',
    Ae = 'AE',
    Af = 'AF',
    Ag = 'AG',
    Ai = 'AI',
    Al = 'AL',
    Am = 'AM',
    Ao = 'AO',
    Aq = 'AQ',
    Ar = 'AR',
    As = 'AS',
    At = 'AT',
    Au = 'AU',
    Aw = 'AW',
    Ax = 'AX',
    Az = 'AZ',
    Ba = 'BA',
    Bb = 'BB',
    Bd = 'BD',
    Be = 'BE',
    Bf = 'BF',
    Bg = 'BG',
    Bh = 'BH',
    Bi = 'BI',
    Bj = 'BJ',
    Bl = 'BL',
    Bm = 'BM',
    Bn = 'BN',
    Bo = 'BO',
    Bq = 'BQ',
    Br = 'BR',
    Bs = 'BS',
    Bt = 'BT',
    Bv = 'BV',
    Bw = 'BW',
    By = 'BY',
    Bz = 'BZ',
    Ca = 'CA',
    Cc = 'CC',
    Cd = 'CD',
    Cf = 'CF',
    Cg = 'CG',
    Ch = 'CH',
    Ci = 'CI',
    Ck = 'CK',
    Cl = 'CL',
    Cm = 'CM',
    Cn = 'CN',
    Co = 'CO',
    Cr = 'CR',
    Cu = 'CU',
    Cv = 'CV',
    Cw = 'CW',
    Cx = 'CX',
    Cy = 'CY',
    Cz = 'CZ',
    De = 'DE',
    Dj = 'DJ',
    Dk = 'DK',
    Dm = 'DM',
    Do = 'DO',
    Dz = 'DZ',
    Ec = 'EC',
    Ee = 'EE',
    Eg = 'EG',
    Eh = 'EH',
    Er = 'ER',
    Es = 'ES',
    Et = 'ET',
    Fi = 'FI',
    Fj = 'FJ',
    Fk = 'FK',
    Fm = 'FM',
    Fo = 'FO',
    Fr = 'FR',
    Ga = 'GA',
    Gb = 'GB',
    Gd = 'GD',
    Ge = 'GE',
    Gf = 'GF',
    Gg = 'GG',
    Gh = 'GH',
    Gi = 'GI',
    Gl = 'GL',
    Gm = 'GM',
    Gn = 'GN',
    Gp = 'GP',
    Gq = 'GQ',
    Gr = 'GR',
    Gs = 'GS',
    Gt = 'GT',
    Gu = 'GU',
    Gw = 'GW',
    Gy = 'GY',
    Hk = 'HK',
    Hm = 'HM',
    Hn = 'HN',
    Hr = 'HR',
    Ht = 'HT',
    Hu = 'HU',
    Id = 'ID',
    Ie = 'IE',
    Il = 'IL',
    Im = 'IM',
    In = 'IN',
    Io = 'IO',
    Iq = 'IQ',
    Ir = 'IR',
    Is = 'IS',
    It = 'IT',
    Je = 'JE',
    Jm = 'JM',
    Jo = 'JO',
    Jp = 'JP',
    Ke = 'KE',
    Kg = 'KG',
    Kh = 'KH',
    Ki = 'KI',
    Km = 'KM',
    Kn = 'KN',
    Kp = 'KP',
    Kr = 'KR',
    Kw = 'KW',
    Ky = 'KY',
    Kz = 'KZ',
    La = 'LA',
    Lb = 'LB',
    Lc = 'LC',
    Li = 'LI',
    Lk = 'LK',
    Lr = 'LR',
    Ls = 'LS',
    Lt = 'LT',
    Lu = 'LU',
    Lv = 'LV',
    Ly = 'LY',
    Ma = 'MA',
    Mc = 'MC',
    Md = 'MD',
    Me = 'ME',
    Mf = 'MF',
    Mg = 'MG',
    Mh = 'MH',
    Mk = 'MK',
    Ml = 'ML',
    Mm = 'MM',
    Mn = 'MN',
    Mo = 'MO',
    Mp = 'MP',
    Mq = 'MQ',
    Mr = 'MR',
    Ms = 'MS',
    Mt = 'MT',
    Mu = 'MU',
    Mv = 'MV',
    Mw = 'MW',
    Mx = 'MX',
    My = 'MY',
    Mz = 'MZ',
    Na = 'NA',
    Nc = 'NC',
    Ne = 'NE',
    Nf = 'NF',
    Ng = 'NG',
    Ni = 'NI',
    Nl = 'NL',
    No = 'NO',
    Np = 'NP',
    Nr = 'NR',
    Nu = 'NU',
    Nz = 'NZ',
    Om = 'OM',
    Pa = 'PA',
    Pe = 'PE',
    Pf = 'PF',
    Pg = 'PG',
    Ph = 'PH',
    Pk = 'PK',
    Pl = 'PL',
    Pm = 'PM',
    Pn = 'PN',
    Pr = 'PR',
    Ps = 'PS',
    Pt = 'PT',
    Pw = 'PW',
    Py = 'PY',
    Qa = 'QA',
    Re = 'RE',
    Ro = 'RO',
    Rs = 'RS',
    Ru = 'RU',
    Rw = 'RW',
    Sa = 'SA',
    Sb = 'SB',
    Sc = 'SC',
    Sd = 'SD',
    Se = 'SE',
    Sg = 'SG',
    Sh = 'SH',
    Si = 'SI',
    Sj = 'SJ',
    Sk = 'SK',
    Sl = 'SL',
    Sm = 'SM',
    Sn = 'SN',
    So = 'SO',
    Sr = 'SR',
    Ss = 'SS',
    St = 'ST',
    Sv = 'SV',
    Sx = 'SX',
    Sy = 'SY',
    Sz = 'SZ',
    Tc = 'TC',
    Td = 'TD',
    Tf = 'TF',
    Tg = 'TG',
    Th = 'TH',
    Tj = 'TJ',
    Tk = 'TK',
    Tl = 'TL',
    Tm = 'TM',
    Tn = 'TN',
    To = 'TO',
    Tr = 'TR',
    Tt = 'TT',
    Tv = 'TV',
    Tw = 'TW',
    Tz = 'TZ',
    Ua = 'UA',
    Ug = 'UG',
    Um = 'UM',
    Us = 'US',
    Uy = 'UY',
    Uz = 'UZ',
    Va = 'VA',
    Vc = 'VC',
    Ve = 'VE',
    Vg = 'VG',
    Vi = 'VI',
    Vn = 'VN',
    Vu = 'VU',
    Wf = 'WF',
    Ws = 'WS',
    Ye = 'YE',
    Yt = 'YT',
    Za = 'ZA',
    Zm = 'ZM',
    Zw = 'ZW',
}

export type CreateBankTransactionsUploadInput = {
    acceptedBankTransactionUsage: Scalars['Boolean']['input']
    bankBic: Scalars['String']['input']
    file: Scalars['Upload']['input']
    token: Scalars['String']['input']
}

/** Response after creating bank transactions upload */
export type CreateBankTransactionsUploadUnion =
    | BankConsentProviderError
    | BankConsentSuccess
    | ValidationError

/** Response after creating bank transactions upload */
export type CreateCollectionAuthorizationUnion =
    | CollectionMandateAttachmentUploadSuccess
    | ValidationError

export type CreateCollectionAuthorizationUploadInput = {
    file: Scalars['Upload']['input']
    token: Scalars['String']['input']
}

export type CreateContractInput = {
    leaseId: Scalars['ID']['input']
    token: Scalars['String']['input']
}

export type CreateContractPayload = {
    __typename?: 'CreateContractPayload'
    attachment?: Maybe<Attachment>
}

/** Properties for creating a deal */
export type CreateDealInput = {
    cocNumber: Scalars['String']['input']
    comments?: InputMaybe<Scalars['String']['input']>
    contactPerson?: InputMaybe<DealContactPersonInput>
    externalSource: DealExternalSourceEnum
    intermediaryToken?: InputMaybe<Scalars['String']['input']>
    leases?: InputMaybe<Array<CreateLeaseInput>>
    marketingOptions?: InputMaybe<MarketingOptions>
    state?: InputMaybe<DealStatesEnum>
}

export type CreateDealPayload = {
    __typename?: 'CreateDealPayload'
    deal?: Maybe<Deal>
    errors?: Maybe<Array<AttributeError>>
}

export type CreateIndicationInput = {
    dealId: Scalars['ID']['input']
}

export type CreateIndicationPayload = {
    __typename?: 'CreateIndicationPayload'
    attachment?: Maybe<Attachment>
}

export type CreateKvoDealPayload = {
    __typename?: 'CreateKvoDealPayload'
    deal?: Maybe<Deal>
    errors?: Maybe<Array<AttributeError>>
}

/** Properties for creating a lease group */
export type CreateLeaseGroupInput = {
    /** Specifies the advertisement url */
    advertisingUrl?: InputMaybe<Scalars['String']['input']>
    /** Amount that customer pays when transferring ownership of object, optional when using monthlyBudget */
    balloonPayment?: InputMaybe<Scalars['Currency']['input']>
    /** ID of the object on the Beezaar marketplace */
    beezaarObjectId?: InputMaybe<Scalars['ID']['input']>
    /** ID of the category to which the object belongs */
    categoryId: Scalars['ID']['input']
    /** Specifies the custom interest percentage the intermediary wants to use for this deal */
    customInterestPercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Specifies whether object has a track and trace system */
    customTrackAndTraceRequired?: InputMaybe<Scalars['Boolean']['input']>
    /** ID of the deal to create the lease for, only required when creating the lease separate from the deal e.g. in a separate mutation */
    dealId?: InputMaybe<Scalars['ID']['input']>
    /** Amount that customer pays up-front when the object is bought, optional when using monthlyBudget */
    downPayment?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer pays up-front to the vender when the object is bought. */
    downPaymentToVendor?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies whether intermediary wants to receive a fee */
    intermediaryFeeEnabledByIntermediary?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies the desired fee as percentage of object for intermediary */
    intermediaryFeePercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Amount that the object is worth, purchasePrice is used as default, can be overwritten with good reason */
    marketValue?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer is willing to pay per month for object, will be used to calculate purchasePrice */
    monthlyBudget?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies the estimated amount of kilometers or hours that object will be used every year */
    objectAnnualUsage?: InputMaybe<Scalars['Int']['input']>
    /** Axle configuration for the object */
    objectAxleConfiguration?: InputMaybe<Scalars['String']['input']>
    /** Belongings and attachments of the object */
    objectBelongings?: InputMaybe<Scalars['String']['input']>
    /** Brand of the object */
    objectBrand?: InputMaybe<Scalars['String']['input']>
    /** License plate number of the object */
    objectLicensePlateNumber?: InputMaybe<Scalars['String']['input']>
    /** Specifies amount of kilometers or hours that object has used */
    objectTotalUsage?: InputMaybe<Scalars['Int']['input']>
    /** Type of the object */
    objectType?: InputMaybe<Scalars['String']['input']>
    /** Specifies whether object is new or used */
    objectUsed?: InputMaybe<Scalars['Boolean']['input']>
    /** Construction date of the object, optional when using monthlyBudget */
    objectYear?: InputMaybe<Scalars['Int']['input']>
    /** Specifies when the planned date when the lease will start */
    plannedStartOn?: InputMaybe<Scalars['Date']['input']>
    /** Amount that customer could pay to transfer ownership of object, only applicable with operational leases, optional when using monthlyBudget */
    purchaseOption?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the object will be bought for, optional when using monthlyBudget */
    purchasePrice?: InputMaybe<Scalars['Currency']['input']>
    /** Amount of objects */
    quantity: Scalars['Int']['input']
    /** Tenor of the lease in months, optional when using monthlyBudget */
    tenor?: InputMaybe<Scalars['Int']['input']>
    /** Value of the object traded in at the vendor. */
    tradeInToVendor?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies the type of financing, preferred argument over use operational or withSale arguments */
    typeOfFinance?: InputMaybe<TypeOfFinanceEnum>
    /** Specifies whether up-front VAT should be financed in a short-term loan */
    vatFinancingEnabled?: InputMaybe<Scalars['Boolean']['input']>
    /** Specifies the vendor by CoC-number where the object will be bought */
    vendorOrganizationCoc?: InputMaybe<Scalars['String']['input']>
    /** Specifies whether object will be rented out to others */
    withRentOut?: InputMaybe<Scalars['Boolean']['input']>
}

export type CreateLeaseGroupPayload = {
    __typename?: 'CreateLeaseGroupPayload'
    errors?: Maybe<Array<AttributeError>>
    leaseGroup?: Maybe<LeaseGroup>
}

/**
 * This are the arguments to create a lease.
 *
 * When you create a lease we always need to know to which deal the lease
 * belongs. You can provide this information in several ways:
 *   1. By creating the lease together with the deal
 *   2. By providing a dealId, this is mostly used by intermediaries
 *
 * When you create a lease you also need to supply the lease components
 * these can be provided in several ways:
 *   1. By specifying individual components e.g. tenor, purchasePrice, downPayment, balloonPayment
 *   2. By specifying a monthlyBudget, we will calculate the components based on the given budget
 *   3. By specifying a monthlyBudget together with individual components, we will calculate the components based
 *      on the given budget where the given components are fixed
 *
 */
export type CreateLeaseInput = {
    /** Specifies the advertisement url */
    advertisingUrl?: InputMaybe<Scalars['String']['input']>
    /** Amount that customer pays when transferring ownership of object, optional when using monthlyBudget */
    balloonPayment?: InputMaybe<Scalars['Currency']['input']>
    /** ID of the object on the Beezaar marketplace */
    beezaarObjectId?: InputMaybe<Scalars['ID']['input']>
    /** ID of the category to which the object belongs */
    categoryId: Scalars['ID']['input']
    /** Specifies the custom interest percentage the intermediary wants to use for this deal */
    customInterestPercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Specifies whether object has a track and trace system */
    customTrackAndTraceRequired?: InputMaybe<Scalars['Boolean']['input']>
    /** ID of the deal to create the lease for, only required when creating the lease separate from the deal e.g. in a separate mutation */
    dealId?: InputMaybe<Scalars['ID']['input']>
    /** Amount that customer pays up-front when the object is bought, optional when using monthlyBudget */
    downPayment?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer pays up-front to the vender when the object is bought. */
    downPaymentToVendor?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies whether intermediary wants to receive a fee */
    intermediaryFeeEnabledByIntermediary?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies the desired fee as percentage of object for intermediary */
    intermediaryFeePercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Amount that the object is worth, purchasePrice is used as default, can be overwritten with good reason */
    marketValue?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer is willing to pay per month for object, will be used to calculate purchasePrice */
    monthlyBudget?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies the estimated amount of kilometers or hours that object will be used every year */
    objectAnnualUsage?: InputMaybe<Scalars['Int']['input']>
    /** Axle configuration for the object */
    objectAxleConfiguration?: InputMaybe<Scalars['String']['input']>
    /** Belongings and attachments of the object */
    objectBelongings?: InputMaybe<Scalars['String']['input']>
    /** Brand of the object */
    objectBrand?: InputMaybe<Scalars['String']['input']>
    /** License plate number of the object */
    objectLicensePlateNumber?: InputMaybe<Scalars['String']['input']>
    /** Specifies amount of kilometers or hours that object has used */
    objectTotalUsage?: InputMaybe<Scalars['Int']['input']>
    /** Type of the object */
    objectType?: InputMaybe<Scalars['String']['input']>
    /** Specifies whether object is new or used */
    objectUsed?: InputMaybe<Scalars['Boolean']['input']>
    /** Construction date of the object, optional when using monthlyBudget */
    objectYear?: InputMaybe<Scalars['Int']['input']>
    /** Specifies when the planned date when the lease will start */
    plannedStartOn?: InputMaybe<Scalars['Date']['input']>
    /** Amount that customer could pay to transfer ownership of object, only applicable with operational leases, optional when using monthlyBudget */
    purchaseOption?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the object will be bought for, optional when using monthlyBudget */
    purchasePrice?: InputMaybe<Scalars['Currency']['input']>
    /** Tenor of the lease in months, optional when using monthlyBudget */
    tenor?: InputMaybe<Scalars['Int']['input']>
    /** Value of the object traded in at the vendor. */
    tradeInToVendor?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies the type of financing, preferred argument over use operational or withSale arguments */
    typeOfFinance?: InputMaybe<TypeOfFinanceEnum>
    /** Specifies whether up-front VAT should be financed in a short-term loan */
    vatFinancingEnabled?: InputMaybe<Scalars['Boolean']['input']>
    /** Specifies the vendor by CoC-number where the object will be bought */
    vendorOrganizationCoc?: InputMaybe<Scalars['String']['input']>
    /** Specifies whether object will be rented out to others */
    withRentOut?: InputMaybe<Scalars['Boolean']['input']>
}

export type CreateLeasePayload = {
    __typename?: 'CreateLeasePayload'
    boundaries?: Maybe<LeaseBoundaries>
    errors?: Maybe<Array<AttributeError>>
    lease?: Maybe<Lease>
}

/** Properties for signing up as an intermediary */
export type CreatePublicIntermediaryInput = {
    cocNumber?: InputMaybe<Scalars['String']['input']>
    name: Scalars['String']['input']
}

export type CreatePublicIntermediaryPayload = {
    __typename?: 'CreatePublicIntermediaryPayload'
    intermediary?: Maybe<PublicIntermediary>
}

export type CreateUboStatementInput = {
    dealId: Scalars['ID']['input']
}

export type CreateUboStatementPayload = {
    __typename?: 'CreateUboStatementPayload'
    attachment?: Maybe<Attachment>
}

export type CreditInvoice = {
    __typename?: 'CreditInvoice'
    activatedOn: Scalars['Date']['output']
    creditInvoiceItems: Array<CreditInvoiceItem>
    documentAllowed: Scalars['Boolean']['output']
    dueOn: Scalars['Date']['output']
    humanActivatedOn: Scalars['String']['output']
    humanDueOn: Scalars['String']['output']
    humanTotalAmount: Scalars['String']['output']
    humanTotalAmountWithVat?: Maybe<Scalars['String']['output']>
    humanTotalVatAmount?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    invoiceType: CreditInvoiceTypeEnum
    reference: Scalars['String']['output']
    salesInvoice?: Maybe<SalesInvoice>
    totalAmount: Scalars['Float']['output']
    totalAmountWithVat?: Maybe<Scalars['Float']['output']>
    totalVatAmount?: Maybe<Scalars['Float']['output']>
}

export type CreditInvoiceItem = {
    __typename?: 'CreditInvoiceItem'
    amount: Scalars['Float']['output']
    amountWithVat?: Maybe<Scalars['Float']['output']>
    humanAmount: Scalars['String']['output']
    humanAmountWithVat?: Maybe<Scalars['String']['output']>
}

export enum CreditInvoiceTypeEnum {
    Activation = 'activation',
    EarlyBuyout = 'early_buyout',
    IncreasedFirstAnnuity = 'increased_first_annuity',
    MonthlyAnnuityTerm = 'monthly_annuity_term',
    Renewal = 'renewal',
    Unknown = 'unknown',
    UpfrontVat = 'upfront_vat',
}

/** Min and max values for a boundary */
export type CurrencyBoundary = {
    __typename?: 'CurrencyBoundary'
    /** Maximal value */
    max: Scalars['Float']['output']
    /** Minimal value */
    min: Scalars['Float']['output']
}

/** Properties for requesting a customer deal */
export type CustomerRequestDealInput = {
    comments?: InputMaybe<Scalars['String']['input']>
    dealId: Scalars['ID']['input']
}

/** Properties for requesting a customer deal */
export type CustomerRequestStartedDealInput = {
    comments?: InputMaybe<Scalars['String']['input']>
    contactPersonEmail?: InputMaybe<Scalars['String']['input']>
    contactPersonName?: InputMaybe<Scalars['String']['input']>
    contactPersonPhone?: InputMaybe<Scalars['String']['input']>
    dealId: Scalars['ID']['input']
    token: Scalars['String']['input']
}

/** Response for customer request deal request */
export type CustomerRequestStartedDealUnion =
    | DealRequestStarted
    | DealRequestStartedCustomerUserCreated
    | DealRequestStartedCustomerUserExists
    | ValidationError

export type CustomerRequestedDeal = {
    __typename?: 'CustomerRequestedDeal'
    deal?: Maybe<Deal>
    errors?: Maybe<Array<AttributeError>>
}

export type CustomerUser = {
    __typename?: 'CustomerUser'
    createdAt: Scalars['DateTime']['output']
    email: Scalars['String']['output']
    id: Scalars['ID']['output']
    /** The version number of the My Beequip application that was used by the customer the last time they logged in, e.g. '2.5.1'. */
    lastUsedMyBeequipVersion?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    notificationPreferences: Array<NotificationEventPreference>
    phone: Scalars['String']['output']
    receiveNotifications: Scalars['Boolean']['output']
    updatedAt: Scalars['DateTime']['output']
}

export type DeactivateUserPayload = {
    __typename?: 'DeactivateUserPayload'
    user?: Maybe<IntermediaryUser>
}

/** A deal */
export type Deal = {
    __typename?: 'Deal'
    attachments?: Maybe<Array<Attachment>>
    /** Totale slottermijn */
    balloonPayment: Scalars['Float']['output']
    /** @deprecated Use token instead */
    beeportToken?: Maybe<Scalars['String']['output']>
    contact?: Maybe<ContactableUnion>
    /** @deprecated Use contactable instead */
    contactPersonEmail?: Maybe<Scalars['String']['output']>
    /** @deprecated Use contactable instead */
    contactPersonName?: Maybe<Scalars['String']['output']>
    /** @deprecated Use contactable instead */
    contactPersonPhone?: Maybe<Scalars['String']['output']>
    createdAt: Scalars['DateTime']['output']
    customerOrganization?: Maybe<Organization>
    customerUser?: Maybe<CustomerUser>
    /** Totale aanbetaling */
    downPayment: Scalars['Float']['output']
    events: Array<Event>
    expectedLeadTimeline?: Maybe<Scalars['String']['output']>
    externalSource?: Maybe<DealExternalSourceEnum>
    firstPaymentGroup?: Maybe<PaymentGroup>
    /** Totale behandelingskosten */
    handlingFee: Scalars['Float']['output']
    humanExternalSource?: Maybe<Scalars['String']['output']>
    humanMonthlyPayment: Scalars['String']['output']
    humanMonthlyPaymentWithVat?: Maybe<Scalars['String']['output']>
    humanMonthlyPaymentWithVatFinancing?: Maybe<Scalars['String']['output']>
    humanPaymentToCustomer?: Maybe<Scalars['String']['output']>
    humanPurchasePrice: Scalars['String']['output']
    id: Scalars['ID']['output']
    identifyingPeople: Array<IdentifyingPerson>
    /**
     * Inactieve prospect
     * @deprecated Replaced by inactiveProspectOrCalculation
     */
    inactiveProspect: Scalars['Boolean']['output']
    /** Inactieve prospect of berekening */
    inactiveProspectOrCalculation: Scalars['Boolean']['output']
    /** Totale fee tussenpersoon */
    intermediaryFee?: Maybe<Scalars['Float']['output']>
    intermediaryFeeEnabledByIntermediary?: Maybe<Scalars['Boolean']['output']>
    intermediaryFeePercentageByIntermediary?: Maybe<Scalars['Float']['output']>
    /** Status voor tussenpersoon */
    intermediaryState: IntermediaryDealStateEnum
    intermediaryUserId?: Maybe<Scalars['ID']['output']>
    intermediaryUserName?: Maybe<Scalars['String']['output']>
    kvo: Scalars['Boolean']['output']
    lastEventAt?: Maybe<Scalars['DateTime']['output']>
    leaseGroups: Array<LeaseGroup>
    leaseOfficerUserId: Scalars['ID']['output']
    leases: Array<Lease>
    maxIntermediaryFeePercentageByIntermediary?: Maybe<
        Scalars['Float']['output']
    >
    minIntermediaryFeePercentageByIntermediary?: Maybe<
        Scalars['Float']['output']
    >
    /** Totale leasestermijn */
    monthlyPayment: Scalars['Float']['output']
    monthlyPaymentWithVat?: Maybe<Scalars['Float']['output']>
    monthlyPaymentWithVatFinancing?: Maybe<Scalars['Float']['output']>
    paymentToCustomer?: Maybe<Scalars['Float']['output']>
    /** Totale aanschafwaarde */
    purchasePrice: Scalars['Float']['output']
    reference: Scalars['String']['output']
    referralLink?: Maybe<Scalars['String']['output']>
    salesOfficerUserId: Scalars['ID']['output']
    /** Indicatie verstuurd */
    sentIndication: Scalars['Boolean']['output']
    signatories: Array<Signatory>
    signing: SigningDossier
    /** Status Beehive */
    state: DealStatesEnum
    /** Totale som Looptijd */
    tenor: Scalars['Int']['output']
    token?: Maybe<Scalars['String']['output']>
    trafficLights: DealTrafficLights
    updatedAt: Scalars['DateTime']['output']
}

/** A deal */
export type DealAttachmentsArgs = {
    excludeTopicTypes?: InputMaybe<Array<AttachmentTopicTypeEnum>>
    excludeTypes?: InputMaybe<Array<AttachmentTypeEnum>>
    filterStates?: InputMaybe<Array<AttachmentStateTypeEnum>>
    filterTopicTypes?: InputMaybe<Array<AttachmentTopicTypeEnum>>
    filterTypes?: InputMaybe<Array<AttachmentTypeEnum>>
    providedBefore?: InputMaybe<DealStatesEnum>
    requestedFrom?: InputMaybe<DealStatesEnum>
}

/** Valid Deal fields to aggregate on */
export enum DealAggregationFieldEnum {
    CreatedAt = 'created_at',
    CustomerOfficer = 'customer_officer',
    CustomerSegment = 'customer_segment',
    CustomerUserId = 'customer_user_id',
    ExternalSource = 'external_source',
    FirstPaymentStatus = 'first_payment_status',
    InLifeState = 'in_life_state',
    IndicationSentAt = 'indication_sent_at',
    IntermediaryId = 'intermediary_id',
    IntermediaryState = 'intermediary_state',
    IntermediaryType = 'intermediary_type',
    IntermediaryUserId = 'intermediary_user_id',
    LaneType = 'lane_type',
    LastEventAt = 'last_event_at',
    LeaseEarlyBuyoutProposalExpiresOn = 'lease_early_buyout_proposal_expires_on',
    LeaseEndOfLifeStates = 'lease_end_of_life_states',
    LeaseInLifeStates = 'lease_in_life_states',
    LeaseOfficer = 'lease_officer',
    LeasePaidOffAt = 'lease_paid_off_at',
    LeasePlannedEndOn = 'lease_planned_end_on',
    LeaseStates = 'lease_states',
    MonthlyBudget = 'monthly_budget',
    SalesOfficer = 'sales_officer',
    State = 'state',
    Team = 'team',
    TypeOfFinanceTypes = 'type_of_finance_types',
    WorkflowType = 'workflow_type',
}

/** Filter options for aggregations on deals */
export type DealAggregationFilterInput = {
    /** Filter aggregations on given fields */
    fields: Array<DealAggregationFieldEnum>
}

/** Abstract class for defining errors as Types */
export type DealAlreadyClaimed = {
    __typename?: 'DealAlreadyClaimed'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

export type DealCollection = {
    __typename?: 'DealCollection'
    /** Aggregations of the DealCollection */
    aggregations: Array<SearchAggregation>
    /** Information about the pagination of the DealCollection */
    pagination: Pagination
    /** Results of the performed search */
    results: Array<Deal>
}

export type DealContactPersonInput = {
    email?: InputMaybe<Scalars['String']['input']>
    name?: InputMaybe<Scalars['String']['input']>
    phone?: InputMaybe<Scalars['String']['input']>
}

/** Valid external sources */
export enum DealExternalSourceEnum {
    Beedirect = 'beedirect',
    Beeport = 'beeport',
    Beezaar = 'beezaar',
    My = 'my',
    PublicApi = 'public_api',
    Widget = 'widget',
}

/** Filter options for deal */
export type DealFilterInput = {
    /** Filter deals on given customer organization(s) */
    customerOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>
    /** Filter deals on given external source(s) */
    externalSources?: InputMaybe<Array<DealExternalSourceEnum>>
    /** Filter deals on given intermediary state(s) */
    intermediaryStates?: InputMaybe<Array<IntermediaryDealStateEnum>>
    /** Filter deals the given intermediary users */
    intermediaryUserIds?: InputMaybe<Array<Scalars['ID']['input']>>
    /** Reject deals on given intermediary state(s) */
    rejectIntermediaryStates?: InputMaybe<Array<IntermediaryDealStateEnum>>
    /** Filter deals on given state(s) */
    states?: InputMaybe<Array<DealStatesEnum>>
}

/** An deal identification request */
export type DealIdentificationRequest = {
    __typename?: 'DealIdentificationRequest'
    deal?: Maybe<Deal>
    id: Scalars['ID']['output']
    state: Scalars['String']['output']
    token: Scalars['String']['output']
}

/** Deal order direction fields */
export enum DealOrderDirectionEnum {
    Asc = 'asc',
    Desc = 'desc',
}

/** Deal order fields */
export enum DealOrderFieldEnum {
    LastEventAt = 'last_event_at',
    LeaseActualEndOn = 'lease_actual_end_on',
    LeaseActualStartOn = 'lease_actual_start_on',
    LeasePlannedEndOn = 'lease_planned_end_on',
    LeasePlannedStartOn = 'lease_planned_start_on',
}

/** Deal order type */
export type DealOrderInput = {
    /** Sorteringwijze */
    direction: DealOrderDirectionEnum
    /** Sorteringveld voor deal */
    field: DealOrderFieldEnum
}

export type DealRequestStarted = {
    __typename?: 'DealRequestStarted'
    deal: Deal
    successReference: Scalars['String']['output']
}

export type DealRequestStartedCustomerUserCreated = {
    __typename?: 'DealRequestStartedCustomerUserCreated'
    deal: Deal
    successReference: Scalars['String']['output']
}

export type DealRequestStartedCustomerUserExists = {
    __typename?: 'DealRequestStartedCustomerUserExists'
    deal: Deal
    successReference: Scalars['String']['output']
}

/** Deal signing state */
export enum DealSigningStateEnum {
    Expired = 'expired',
    Generating = 'generating',
    GeneratingFailed = 'generating_failed',
    Pending = 'pending',
    Provided = 'provided',
    Rejected = 'rejected',
    SignatoryChoice = 'signatory_choice',
    Signed = 'signed',
    Unready = 'unready',
}

/** Deal signing type */
export enum DealSigningTypeEnum {
    Digital = 'digital',
    Manual = 'manual',
    Unknown = 'unknown',
}

/** Deal states */
export enum DealStatesEnum {
    BoughtOffEarly = 'bought_off_early',
    Calculation = 'calculation',
    Cancelled = 'cancelled',
    Completed = 'completed',
    Complied = 'complied',
    CompliedSoft4leaseExported = 'complied_soft4lease_exported',
    ConditionallyCompleted = 'conditionally_completed',
    ContractSent = 'contract_sent',
    Dissolved = 'dissolved',
    DissolvementRequested = 'dissolvement_requested',
    DossierCompleted = 'dossier_completed',
    EarlyBuyoutApproved = 'early_buyout_approved',
    EarlyBuyoutPrepared = 'early_buyout_prepared',
    EarlyBuyoutSent = 'early_buyout_sent',
    HardKycApproved = 'hard_kyc_approved',
    HardKycComplete = 'hard_kyc_complete',
    IncompletelyRequested = 'incompletely_requested',
    LesseeChangePrepared = 'lessee_change_prepared',
    LesseeChanged = 'lessee_changed',
    LgdApproved = 'lgd_approved',
    PaidOff = 'paid_off',
    PayoutPrepared = 'payout_prepared',
    PdApproved = 'pd_approved',
    PdApprovedSoftKycComplete = 'pd_approved_soft_kyc_complete',
    PdFinancialsNeeded = 'pd_financials_needed',
    PdFinancialsNeededSoftKycComplete = 'pd_financials_needed_soft_kyc_complete',
    PendingRejection = 'pending_rejection',
    Prospect = 'prospect',
    QuoteApproved = 'quote_approved',
    QuoteApprovedLegalRequired = 'quote_approved_legal_required',
    QuoteComplete = 'quote_complete',
    Rejected = 'rejected',
    Renewed = 'renewed',
    RenewedOrPaidOff = 'renewed_or_paid_off',
    RequestStarted = 'request_started',
    Requested = 'requested',
    SignedContractApproved = 'signed_contract_approved',
    SignedContractCompleted = 'signed_contract_completed',
    SignedContractReceived = 'signed_contract_received',
    Soft4leaseExported = 'soft4lease_exported',
    SoftKycComplete = 'soft_kyc_complete',
}

export type DealSummary = {
    __typename?: 'DealSummary'
    createdAt: Scalars['String']['output']
    customerOrganization?: Maybe<Organization>
    id: Scalars['ID']['output']
    intermediaryFee: Scalars['Float']['output']
    intermediaryState: IntermediaryDealStateEnum
    intermediaryUserName?: Maybe<Scalars['String']['output']>
    lossReason?: Maybe<Scalars['String']['output']>
    purchasePrice: Scalars['Float']['output']
    rejectReason?: Maybe<Scalars['String']['output']>
}

/** Various traffic lights for the deal e.g. auto-LGD, auto-PD and auto-soft-KYC */
export type DealTrafficLights = {
    __typename?: 'DealTrafficLights'
    autoLgdTrafficLight?: Maybe<AutoLgdEnum>
    autoPdTrafficLight?: Maybe<AutoPdEnum>
    autoSoftKycTrafficLight?: Maybe<AutoSoftKycEnum>
    bankCreditAnalysisRequirementTrafficLight?: Maybe<BankCreditAnalysisRequirementTrafficLightEnum>
    bankTransactionsRequirementTrafficLight?: Maybe<BankTransactionsRequirementTrafficLightEnum>
    /** @deprecated Please use lease.eifTrafficLight instead */
    eifTrafficLight?: Maybe<EifTrafficLightEnum>
}

/** The connection type for DealSummary. */
export type DealsSummaryConnection = {
    __typename?: 'DealsSummaryConnection'
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<DealsSummaryEdge>>>
    maxPageSize: Scalars['Int']['output']
    /** A list of nodes. */
    nodes?: Maybe<Array<Maybe<DealSummary>>>
    /** Information to aid in pagination. */
    pageInfo: PageInfo
    totalCount: Scalars['Int']['output']
}

/** An edge in a connection. */
export type DealsSummaryEdge = {
    __typename?: 'DealsSummaryEdge'
    /** A cursor for use in pagination. */
    cursor: Scalars['String']['output']
    /** The item at the end of the edge. */
    node?: Maybe<DealSummary>
}

/** Properties for delete individual or all files of an attachment */
export type DeleteAttachmentInput = {
    filename?: InputMaybe<Scalars['String']['input']>
    /** Authentication token of an Attachment */
    token: Scalars['String']['input']
}

export type DeleteAttachmentPayload = {
    __typename?: 'DeleteAttachmentPayload'
    attachment?: Maybe<Attachment>
}

export type DeleteLeaseGroupPayload = {
    __typename?: 'DeleteLeaseGroupPayload'
    leaseGroup?: Maybe<LeaseGroup>
}

export type DeleteLeasePayload = {
    __typename?: 'DeleteLeasePayload'
    lease?: Maybe<Lease>
}

export type DownloadAnnuityScheduleInput = {
    /** ID of the lease */
    leaseId: Scalars['ID']['input']
}

export type DownloadAnnuitySchedulePayload = {
    __typename?: 'DownloadAnnuitySchedulePayload'
    attachment: Attachment
}

export type DownloadVatAnnuityScheduleInput = {
    /** ID of the lease */
    leaseId: Scalars['ID']['input']
}

export type DownloadVatAnnuitySchedulePayload = {
    __typename?: 'DownloadVatAnnuitySchedulePayload'
    attachment: Attachment
}

export type DownloadYearlyOverviewInput = {
    /** ID of the organization */
    organizationId: Scalars['ID']['input']
    year: Scalars['Int']['input']
}

export type DownloadYearlyOverviewPayload = {
    __typename?: 'DownloadYearlyOverviewPayload'
    attachment: Attachment
}

/** Valid colors for EIF */
export enum EifTrafficLightEnum {
    Green = 'green',
    Red = 'red',
}

/** An Event */
export type Event = {
    __typename?: 'Event'
    createdAt: Scalars['DateTime']['output']
    deal: Deal
    id: Scalars['ID']['output']
    label: Scalars['String']['output']
    owner: UserUnion
    toIntermediaryState?: Maybe<IntermediaryDealStateEnum>
    type: Scalars['String']['output']
    updatedAt: Scalars['DateTime']['output']
}

/** Properties for signing up as an intermediary */
export type FindOrCreateIntermediaryInput = {
    cocNumber?: InputMaybe<Scalars['String']['input']>
    name: Scalars['String']['input']
}

export type FindOrCreateIntermediaryPayload = {
    __typename?: 'FindOrCreateIntermediaryPayload'
    intermediary?: Maybe<Intermediary>
}

export type GenerateCreditInvoiceDocumentInput = {
    creditInvoiceId: Scalars['ID']['input']
    organizationId: Scalars['ID']['input']
}

export type GenerateCreditInvoiceDocumentPayload = {
    __typename?: 'GenerateCreditInvoiceDocumentPayload'
    document: Scalars['String']['output']
}

export type GenerateSalesInvoiceDocumentInput = {
    organizationId: Scalars['ID']['input']
    salesInvoiceId: Scalars['ID']['input']
}

export type GenerateSalesInvoiceDocumentPayload = {
    __typename?: 'GenerateSalesInvoiceDocumentPayload'
    document: Scalars['String']['output']
}

export type GenerateUboStatementFormDossierError = {
    __typename?: 'GenerateUboStatementFormDossierError'
    errors: Array<Scalars['String']['output']>
    uboStatementFormDossier: UboStatementFormDossier
}

export type GenerateUboStatementFormDossierInput = {
    token: Scalars['String']['input']
}

export type GenerateUboStatementFormDossierPayload = {
    __typename?: 'GenerateUboStatementFormDossierPayload'
    attachment: Attachment
    uboStatementFormDossier: UboStatementFormDossier
}

export type GenerateUboStatementFormUnion =
    | GenerateUboStatementFormDossierError
    | GenerateUboStatementFormDossierPayload

/** Valid options to persist the authentication of the user */
export enum GraphqlAuthenticationPersistenceTypeEnum {
    /** Persist the authentication by receiving a JWT to pass in the Authorization header */
    JwtToken = 'jwt_token',
    /** Persist the authentication by receiving a cookie */
    SessionCookie = 'session_cookie',
}

/** Valid options for the scope to notify about the persisted authentication in the cookies */
export enum GraphqlAuthenticationSessionScopeEnum {
    Beeport = 'beeport',
    MyBeequip = 'my_beequip',
}

/** iDEAL payment details */
export type IdealPayment = {
    __typename?: 'IdealPayment'
    amount: Scalars['Float']['output']
    checkoutUrl: Scalars['String']['output']
    description: Scalars['String']['output']
    humanAmount: Scalars['String']['output']
    id: Scalars['ID']['output']
    state: IdealPaymentStateEnum
}

/** Valid states for iDEAL payments */
export enum IdealPaymentStateEnum {
    Canceled = 'canceled',
    Deactivated = 'deactivated',
    Error = 'error',
    Expired = 'expired',
    Failed = 'failed',
    New = 'new',
    Paid = 'paid',
    Requested = 'requested',
}

/** An identifying person */
export type IdentifyingPerson = {
    __typename?: 'IdentifyingPerson'
    /**
     * url to start the identification, add the params ?deal_token={deal_token}&attachment_id={attachment_token}
     *                                                     to the url to get redirected back to the right deal and attachment
     */
    digitalIdentificationUrl?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    identified: Scalars['Boolean']['output']
    /** will be filled if the last attempt was rejected by signicat */
    lastKnownAttemptAt?: Maybe<Scalars['DateTime']['output']>
    /** will be filled if the last attempt was rejected by signicat */
    lastKnownAttemptRejected: Scalars['Boolean']['output']
    name: Scalars['String']['output']
}

/** Abstract class for defining errors as Types */
export type IncorrectCredentials = {
    __typename?: 'IncorrectCredentials'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

export type Intermediary = {
    __typename?: 'Intermediary'
    broker: Scalars['Boolean']['output']
    canCreateKvoDeals: Scalars['Boolean']['output']
    canUseIntermediaryContribution: Scalars['Boolean']['output']
    canUseReducedDownpayment: Scalars['Boolean']['output']
    canUseZeroDownpayment: Scalars['Boolean']['output']
    cocNumber: Scalars['String']['output']
    createdAt: Scalars['DateTime']['output']
    eligibleForAutoLgd: Scalars['Boolean']['output']
    feePercentage: Scalars['Float']['output']
    fixedFee: Scalars['Int']['output']
    fixedHandlingFee?: Maybe<Scalars['Float']['output']>
    id: Scalars['ID']['output']
    interestPercentageDiscount: Scalars['Float']['output']
    interestPercentageIncrement: Scalars['Float']['output']
    intermediaryType: Scalars['String']['output']
    logo?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    showLogo: Scalars['Boolean']['output']
    supportedLogoContentTypes: Array<Scalars['String']['output']>
    supportedLogoExtensions: Array<Scalars['String']['output']>
    token?: Maybe<Scalars['String']['output']>
    updatedAt: Scalars['DateTime']['output']
    users?: Maybe<Array<IntermediaryUser>>
    usersCanAccessIntermediaryFee: Scalars['Boolean']['output']
    vendor: Scalars['Boolean']['output']
    vendorObjectBrand?: Maybe<Scalars['String']['output']>
}

/** Properties commenting on a deal */
export type IntermediaryCommentDealInput = {
    comments?: InputMaybe<Scalars['String']['input']>
    dealId: Scalars['ID']['input']
}

export type IntermediaryCommentDealPayload = {
    __typename?: 'IntermediaryCommentDealPayload'
    deal?: Maybe<Deal>
    event?: Maybe<Event>
}

/** Valid intermediary states */
export enum IntermediaryDealStateEnum {
    Cancelled = 'cancelled',
    Completed = 'completed',
    ContractSent = 'contract_sent',
    ContractSigned = 'contract_signed',
    Dissolved = 'dissolved',
    Prospect = 'prospect',
    Rejected = 'rejected',
    RequestStarted = 'request_started',
    Requested = 'requested',
    SignedContractApproved = 'signed_contract_approved',
}

/** Properties for updating the intermediary fee percentage */
export type IntermediaryFeePercentageByIntermediaryInput = {
    dealId: Scalars['ID']['input']
    intermediaryFeeEnabledByIntermediary: Scalars['Boolean']['input']
    intermediaryFeePercentageByIntermediary: Scalars['Float']['input']
}

/** Properties for requesting a deal */
export type IntermediaryRequestDealInput = {
    comments?: InputMaybe<Scalars['String']['input']>
    contactPersonEmail?: InputMaybe<Scalars['String']['input']>
    contactPersonName?: InputMaybe<Scalars['String']['input']>
    contactPersonPhone?: InputMaybe<Scalars['String']['input']>
    dealId: Scalars['ID']['input']
}

export type IntermediaryRequestDealPayload = {
    __typename?: 'IntermediaryRequestDealPayload'
    event?: Maybe<Event>
}

/** Properties for requesting a deal */
export type IntermediaryRequestStartedDealInput = {
    comments?: InputMaybe<Scalars['String']['input']>
    dealId: Scalars['ID']['input']
}

export type IntermediaryRequestStartedDealPayload = {
    __typename?: 'IntermediaryRequestStartedDealPayload'
    event?: Maybe<Event>
}

/** Properties for undoing a started request on a deal */
export type IntermediaryUndoRequestStartedDealInput = {
    dealId: Scalars['ID']['input']
}

export type IntermediaryUndoRequestStartedDealPayload = {
    __typename?: 'IntermediaryUndoRequestStartedDealPayload'
    event?: Maybe<Event>
}

/** Properties for updating a contact of a deal */
export type IntermediaryUpdateDealContactInput = {
    contactPersonEmail?: InputMaybe<Scalars['String']['input']>
    contactPersonName?: InputMaybe<Scalars['String']['input']>
    contactPersonPhone?: InputMaybe<Scalars['String']['input']>
    id: Scalars['ID']['input']
}

export type IntermediaryUpdateDealContactPayload = {
    __typename?: 'IntermediaryUpdateDealContactPayload'
    deal: Deal
}

export type IntermediaryUser = {
    __typename?: 'IntermediaryUser'
    acceptedTermsAt?: Maybe<Scalars['DateTime']['output']>
    createdAt: Scalars['DateTime']['output']
    email: Scalars['String']['output']
    id: Scalars['ID']['output']
    intermediary: Intermediary
    intermediaryAdmin?: Maybe<Scalars['Boolean']['output']>
    intermediaryClosedDealsCount: Scalars['Int']['output']
    intermediaryProspectDealsCount: Scalars['Int']['output']
    intermediaryRequestedDealsCount: Scalars['Int']['output']
    /** The version number of the Beeport application that was used by the intermediary the last time they logged in, e.g. '2.5.1'. */
    lastUsedBeeportVersion?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    notificationPreferences: Array<NotificationEventPreference>
    phone: Scalars['String']['output']
    receiveNotifications: Scalars['Boolean']['output']
    updatedAt: Scalars['DateTime']['output']
}

/** Abstract class for defining errors as Types */
export type InvalidDealToken = {
    __typename?: 'InvalidDealToken'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

/** Abstract class for defining errors as Types */
export type InvalidOrganizationToken = {
    __typename?: 'InvalidOrganizationToken'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

export type Invoice = {
    __typename?: 'Invoice'
    amount: Scalars['Float']['output']
    amountWithVat?: Maybe<Scalars['Float']['output']>
    dueOn: Scalars['Date']['output']
    humanAmount: Scalars['String']['output']
    humanAmountWithVat?: Maybe<Scalars['String']['output']>
    humanDueOn: Scalars['String']['output']
    humanInvoicedOn: Scalars['String']['output']
    humanTotalAmountWithVat?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    invoiceItems: Array<InvoiceItem>
    invoicedOn: Scalars['String']['output']
    reference: Scalars['String']['output']
    state: InvoiceStateEnum
    totalAmountWithVat?: Maybe<Scalars['Float']['output']>
}

export type InvoiceItem = {
    __typename?: 'InvoiceItem'
    amount: Scalars['Float']['output']
    humanAmount: Scalars['String']['output']
    humanItemType?: Maybe<Scalars['String']['output']>
    itemType: InvoiceItemTypeEnum
    lease?: Maybe<LeaseSummary>
}

/** Invoice item type */
export enum InvoiceItemTypeEnum {
    Deposit = 'deposit',
    DownPayment = 'down_payment',
    HandlingFee = 'handling_fee',
    Installment = 'installment',
    Other = 'other',
    UpfrontVat = 'upfront_vat',
}

/** States of invoices */
export enum InvoiceStateEnum {
    New = 'new',
    Paid = 'paid',
    PartiallyPaid = 'partially_paid',
}

export type InvoiceUnion = CreditInvoice | Invoice | SalesInvoice

/** A lease */
export type Lease = {
    __typename?: 'Lease'
    accountingSystemReference?: Maybe<Scalars['String']['output']>
    actualEndOn?: Maybe<Scalars['DateTime']['output']>
    actualStartOn?: Maybe<Scalars['DateTime']['output']>
    actualTerms: Array<AnnuityTerm>
    advertisingUrl?: Maybe<Scalars['String']['output']>
    attachments?: Maybe<Array<Attachment>>
    /** Slottermijn */
    balloonPayment: Scalars['Float']['output']
    balloonPaymentVatPercentage?: Maybe<Scalars['Float']['output']>
    balloonPaymentWithVat?: Maybe<Scalars['Float']['output']>
    /** The ID of the object on the Beezaar marketplace */
    beezaarObjectId?: Maybe<Scalars['ID']['output']>
    boundaries?: Maybe<LeaseBoundaries>
    category: Category
    createdAt: Scalars['DateTime']['output']
    cumulativeMarkUpInterestPercentage?: Maybe<Scalars['Float']['output']>
    currentFairMarketValue?: Maybe<Scalars['Float']['output']>
    customInterestPercentageByIntermediary?: Maybe<Scalars['Float']['output']>
    customTrackAndTraceRequired: Scalars['Boolean']['output']
    deal: Deal
    deliveryVatPercentage?: Maybe<Scalars['Float']['output']>
    /** Aanbetaling */
    downPayment: Scalars['Float']['output']
    downPaymentToUs?: Maybe<Scalars['Float']['output']>
    downPaymentToUsVatPercentage?: Maybe<Scalars['Float']['output']>
    downPaymentToUsWithVat?: Maybe<Scalars['Float']['output']>
    downPaymentToVendor?: Maybe<Scalars['Float']['output']>
    downPaymentToVendorEnabledByExternalUser?: Maybe<
        Scalars['Boolean']['output']
    >
    downPaymentToVendorVatPercentage?: Maybe<Scalars['Float']['output']>
    downPaymentToVendorWithVat?: Maybe<Scalars['Float']['output']>
    downPaymentVatPercentage?: Maybe<Scalars['Float']['output']>
    downPaymentWithVat?: Maybe<Scalars['Float']['output']>
    eifEndDate: Scalars['DateTime']['output']
    eifTrafficLight?: Maybe<EifTrafficLightEnum>
    /** @deprecated Use accountingSystemReference instead */
    externalReference?: Maybe<Scalars['String']['output']>
    /** @deprecated Please use fairMarketValues instead */
    fairMarketValue?: Maybe<Array<Scalars['String']['output']>>
    fairMarketValues?: Maybe<Array<Scalars['String']['output']>>
    firstPayment?: Maybe<Payment>
    /** Behandelingskosten */
    handlingFee: Scalars['Float']['output']
    handlingFeeVatPercentage: Scalars['Float']['output']
    handlingFeeWithVat: Scalars['Float']['output']
    humanBalloonPayment: Scalars['String']['output']
    humanBalloonPaymentVatPercentage?: Maybe<Scalars['String']['output']>
    humanBalloonPaymentWithVat?: Maybe<Scalars['String']['output']>
    humanCumulativeMarkUpInterestPercentage?: Maybe<Scalars['String']['output']>
    humanDeliveryVatPercentage?: Maybe<Scalars['String']['output']>
    humanDownPayment: Scalars['String']['output']
    humanDownPaymentToUs?: Maybe<Scalars['String']['output']>
    humanDownPaymentToUsVatPercentage?: Maybe<Scalars['String']['output']>
    humanDownPaymentToUsWithVat?: Maybe<Scalars['String']['output']>
    humanDownPaymentToVendor?: Maybe<Scalars['String']['output']>
    humanDownPaymentToVendorVatPercentage?: Maybe<Scalars['String']['output']>
    humanDownPaymentToVendorWithVat?: Maybe<Scalars['String']['output']>
    humanDownPaymentVatPercentage?: Maybe<Scalars['String']['output']>
    humanDownPaymentWithVat?: Maybe<Scalars['String']['output']>
    humanHandlingFee: Scalars['String']['output']
    humanHandlingFeeVatPercentage: Scalars['String']['output']
    humanHandlingFeeWithVat: Scalars['String']['output']
    humanInterestPercentage?: Maybe<Scalars['String']['output']>
    humanInvoicedPaymentToUs?: Maybe<Scalars['String']['output']>
    humanMonthlyBudget?: Maybe<Scalars['String']['output']>
    humanMonthlyPayment: Scalars['String']['output']
    humanMonthlyPaymentVatPercentage?: Maybe<Scalars['String']['output']>
    humanMonthlyPaymentWithVat?: Maybe<Scalars['String']['output']>
    humanMonthlyPaymentWithVatFinancing?: Maybe<Scalars['String']['output']>
    humanPaymentToCustomer?: Maybe<Scalars['String']['output']>
    humanPrincipal: Scalars['String']['output']
    humanPurchaseOption?: Maybe<Scalars['String']['output']>
    humanPurchaseOptionVatPercentage?: Maybe<Scalars['String']['output']>
    humanPurchaseOptionWithVat?: Maybe<Scalars['String']['output']>
    humanPurchasePrice: Scalars['String']['output']
    humanPurchasePriceVatPercentage?: Maybe<Scalars['String']['output']>
    humanPurchasePriceWithVat?: Maybe<Scalars['String']['output']>
    humanPurchasePriceWithoutVehicleTax?: Maybe<Scalars['String']['output']>
    humanPurchasePriceWithoutVehicleTaxWithVat?: Maybe<
        Scalars['String']['output']
    >
    humanServiceVatPercentage?: Maybe<Scalars['String']['output']>
    humanTaxablePrincipal?: Maybe<Scalars['String']['output']>
    humanTradeInToVendor?: Maybe<Scalars['String']['output']>
    humanTradeInToVendorVatPercentage?: Maybe<Scalars['String']['output']>
    humanTradeInToVendorWithVat?: Maybe<Scalars['String']['output']>
    /** @deprecated Use humanDeliveryVatPercentage or humanServiceVatPercentage instead */
    humanVatPercentage?: Maybe<Scalars['String']['output']>
    humanVehiclePurchaseTax?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    interestPercentage?: Maybe<Scalars['Float']['output']>
    /** Fee tussenpersoon */
    intermediaryFee?: Maybe<Scalars['Float']['output']>
    intermediaryFeeEnabledByIntermediary?: Maybe<Scalars['Boolean']['output']>
    intermediaryFeePercentageByIntermediary?: Maybe<Scalars['Float']['output']>
    /** Bijdrage tussenpersoon */
    intermediaryFixedContribution?: Maybe<Scalars['Float']['output']>
    /** Doelrente tussenpersoon */
    intermediaryTargetInterestPercentage?: Maybe<Scalars['Float']['output']>
    invoicedPaymentToUs?: Maybe<Scalars['Float']['output']>
    invoices: Array<Invoice>
    lastEventAt?: Maybe<Scalars['DateTime']['output']>
    lastImportFromAccountingSystemAt?: Maybe<Scalars['DateTime']['output']>
    latestEndOn?: Maybe<Scalars['Date']['output']>
    lecturaMarketValue?: Maybe<Scalars['Float']['output']>
    marketValue?: Maybe<Scalars['Float']['output']>
    /** Leasebudget */
    monthlyBudget?: Maybe<Scalars['Int']['output']>
    /** Leasetermijn */
    monthlyPayment: Scalars['Float']['output']
    monthlyPaymentVatPercentage?: Maybe<Scalars['Float']['output']>
    monthlyPaymentWithVat?: Maybe<Scalars['Float']['output']>
    monthlyPaymentWithVatFinancing?: Maybe<Scalars['Float']['output']>
    objectAnnualUsage?: Maybe<Scalars['Int']['output']>
    objectAxleConfiguration?: Maybe<Scalars['String']['output']>
    objectBelongings?: Maybe<Scalars['String']['output']>
    objectBrand?: Maybe<Scalars['String']['output']>
    objectChassisNumber?: Maybe<Scalars['String']['output']>
    objectIdentification: Scalars['String']['output']
    objectIdentificationMark?: Maybe<Scalars['String']['output']>
    objectLicensePlateNumber?: Maybe<Scalars['String']['output']>
    objectSerialNumber?: Maybe<Scalars['String']['output']>
    objectTotalUsage?: Maybe<Scalars['Int']['output']>
    objectType?: Maybe<Scalars['String']['output']>
    objectUsed: Scalars['Boolean']['output']
    objectYear: Scalars['Int']['output']
    /** @deprecated Use typeOfFinance instead */
    operational: Scalars['Boolean']['output']
    paidOutAt?: Maybe<Scalars['Date']['output']>
    paymentToCustomer?: Maybe<Scalars['Float']['output']>
    payments?: Maybe<Array<Payment>>
    plannedEndOn?: Maybe<Scalars['Date']['output']>
    plannedStartOn?: Maybe<Scalars['Date']['output']>
    plannedStartOnConfirmedByExternalUser?: Maybe<Scalars['Boolean']['output']>
    postCalculationBoundaries?: Maybe<PostCalculationBoundaries>
    /** Leasebedrag */
    principal: Scalars['Float']['output']
    /** Koopoptie */
    purchaseOption?: Maybe<Scalars['Int']['output']>
    purchaseOptionVatPercentage?: Maybe<Scalars['Float']['output']>
    purchaseOptionWithVat?: Maybe<Scalars['Float']['output']>
    /** Aanschafwaarde */
    purchasePrice: Scalars['Float']['output']
    purchasePriceVatPercentage?: Maybe<Scalars['Float']['output']>
    purchasePriceWithVat?: Maybe<Scalars['Float']['output']>
    purchasePriceWithoutVehicleTax?: Maybe<Scalars['Float']['output']>
    purchasePriceWithoutVehicleTaxWithVat?: Maybe<Scalars['Float']['output']>
    rdwObjectBrand?: Maybe<Scalars['String']['output']>
    rdwObjectType?: Maybe<Scalars['String']['output']>
    reference: Scalars['String']['output']
    region: Region
    serviceVatPercentage?: Maybe<Scalars['Float']['output']>
    showCumulativeMarkUpPlusIrsPercentage: Scalars['Boolean']['output']
    showInterestPercentage: Scalars['Boolean']['output']
    /** Status Beehive */
    state: LeaseStatesEnum
    taxablePrincipal?: Maybe<Scalars['Float']['output']>
    /** Looptijd */
    tenor: Scalars['Int']['output']
    tradeInToVendor?: Maybe<Scalars['Float']['output']>
    tradeInToVendorEnabledByExternalUser?: Maybe<Scalars['Boolean']['output']>
    tradeInToVendorVatPercentage?: Maybe<Scalars['Float']['output']>
    tradeInToVendorWithVat?: Maybe<Scalars['Float']['output']>
    typeOfFinance: TypeOfFinanceEnum
    updatedAt: Scalars['DateTime']['output']
    vatFinancing: VatFinancing
    /** @deprecated Use deliveryVatPercentage or serviceVatPercentage instead */
    vatPercentage?: Maybe<Scalars['Float']['output']>
    vehiclePurchaseTax?: Maybe<Scalars['Int']['output']>
    vendorOrganization?: Maybe<Organization>
    withRentOut: Scalars['Boolean']['output']
    /**
     * Sale & leaseback
     * @deprecated Use typeOfFinance instead
     */
    withSale: Scalars['Boolean']['output']
}

/** A lease */
export type LeaseAttachmentsArgs = {
    excludeTopicTypes?: InputMaybe<Array<AttachmentTopicTypeEnum>>
    excludeTypes?: InputMaybe<Array<AttachmentTypeEnum>>
    filterStates?: InputMaybe<Array<AttachmentStateTypeEnum>>
    filterTopicTypes?: InputMaybe<Array<AttachmentTopicTypeEnum>>
    filterTypes?: InputMaybe<Array<AttachmentTypeEnum>>
    providedBefore?: InputMaybe<DealStatesEnum>
    requestedFrom?: InputMaybe<DealStatesEnum>
}

/** A lease */
export type LeaseInvoicesArgs = {
    filterTypes?: InputMaybe<Array<InvoiceItemTypeEnum>>
}

/** A lease */
export type LeasePaymentsArgs = {
    filterStates?: InputMaybe<Array<PaymentStateEnum>>
    filterTypes?: InputMaybe<Array<PaymentTypeEnum>>
}

/** Lease boundaries */
export type LeaseBoundaries = {
    __typename?: 'LeaseBoundaries'
    /** Indicates if the object values are all within boundaries */
    acceptable: Scalars['Boolean']['output']
    /** Balloon payment boundaries */
    balloonPayment: CurrencyBoundary
    /** Down payment boundaries */
    downPayment: CurrencyBoundary
    /** Object year boundaries */
    objectYear: ObjectYearBoundary
    /** Purchase option boundaries */
    purchaseOption: CurrencyBoundary
    /** Purchase price boundaries */
    purchasePrice: CurrencyBoundary
    /** Tenor boundaries */
    tenor: YearMonthBoundary
}

export type LeaseBoundariesInput = {
    /** Amount that customer pays when transferring ownership of object, optional when using monthlyBudget */
    balloonPayment?: InputMaybe<Scalars['Currency']['input']>
    /** ID of the category to which the object belongs */
    categoryId?: InputMaybe<Scalars['ID']['input']>
    /** ID of the deal, used to scope the leaseId as intermediary or customer user */
    dealId?: InputMaybe<Scalars['ID']['input']>
    /** Amount that customer pays up-front when the object is bought, optional when using monthlyBudget */
    downPayment?: InputMaybe<Scalars['Currency']['input']>
    /** Token of the intermediary, used to apply intermediary settings */
    intermediaryToken?: InputMaybe<Scalars['String']['input']>
    /** ID of the lease to base the boundaries on, only required when using an existing lease */
    leaseId?: InputMaybe<Scalars['ID']['input']>
    /** Amount that the object is wort, purchasePrice is used as default, can be overwritten with good reason */
    marketValue?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer is willing to pay per month for object, will be used to calculate purchasePrice */
    monthlyBudget?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies whether object is new or used */
    objectUsed?: InputMaybe<Scalars['Boolean']['input']>
    /** Construction date of the object */
    objectYear?: InputMaybe<Scalars['Int']['input']>
    /** Specifies when the planned date when the lease will start */
    plannedStartOn?: InputMaybe<Scalars['Date']['input']>
    /** Amount that customer could pay to transfer ownership of object, only applicable with operational leases, optional when using monthlyBudget */
    purchaseOption?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the object will be bought for, optional when using monthlyBudget */
    purchasePrice?: InputMaybe<Scalars['Currency']['input']>
    /** Tenor of the lease in months, optional when using monthlyBudget */
    tenor?: InputMaybe<Scalars['Int']['input']>
    /** Token of the deal, used to scope the leaseId as anonymous user */
    token?: InputMaybe<Scalars['String']['input']>
    /** Specifies the type of financing, preferred argument over use operational or withSale arguments */
    typeOfFinance?: InputMaybe<TypeOfFinanceEnum>
}

export type LeaseBoundariesPayload = {
    __typename?: 'LeaseBoundariesPayload'
    boundaries?: Maybe<LeaseBoundaries>
}

/** Lease calculation result */
export type LeaseCalculation = {
    __typename?: 'LeaseCalculation'
    /** Slottermijn */
    balloonPayment: Scalars['Float']['output']
    /** Fair market value vandaag */
    currentFairMarketValue?: Maybe<Scalars['Float']['output']>
    dealTrafficLights: DealTrafficLights
    /** Aanbetaling */
    downPayment: Scalars['Float']['output']
    eifTrafficLight?: Maybe<EifTrafficLightEnum>
    /** @deprecated Please use fairMarketValues instead */
    fairMarketValue?: Maybe<Array<Scalars['String']['output']>>
    fairMarketValues?: Maybe<Array<Scalars['String']['output']>>
    /** Behandelingskosten */
    handlingFee: Scalars['Float']['output']
    /** Fee tussenpersoon */
    intermediaryFee: Scalars['Float']['output']
    /** Bijdrage tussenpersoon */
    intermediaryFixedContribution?: Maybe<Scalars['Float']['output']>
    /** Doelrente tussenpersoon */
    intermediaryTargetInterestPercentage?: Maybe<Scalars['Float']['output']>
    monthlyBudget?: Maybe<Scalars['Int']['output']>
    /** Leasetermijn */
    monthlyPayment: Scalars['Float']['output']
    /** Koopoptie */
    purchaseOption?: Maybe<Scalars['Float']['output']>
    /** Aanschafbedrag */
    purchasePrice: Scalars['Float']['output']
    /** Type suggestie */
    suggestedType?: Maybe<LeaseSuggestedTypeEnum>
    /** Looptijd */
    tenor: Scalars['Int']['output']
    totalCosts: Scalars['Float']['output']
}

export type LeaseCollection = {
    __typename?: 'LeaseCollection'
    /** Aggregations of the LeaseCollection */
    aggregations: Array<SearchAggregation>
    /** Information about the pagination of the LeaseCollection */
    pagination: Pagination
    /** Results of the performed search */
    results: Array<Lease>
}

/** Filter options for leases */
export type LeaseFilterInput = {
    customerOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>
    states?: InputMaybe<Array<LeaseStatesEnum>>
}

/** A lease group */
export type LeaseGroup = {
    __typename?: 'LeaseGroup'
    accountingSystemReference?: Maybe<Scalars['String']['output']>
    actualEndOn?: Maybe<Scalars['DateTime']['output']>
    actualStartOn?: Maybe<Scalars['DateTime']['output']>
    actualTerms: Array<AnnuityTerm>
    advertisingUrl?: Maybe<Scalars['String']['output']>
    attachments?: Maybe<Array<Attachment>>
    /** Slottermijn */
    balloonPayment: Scalars['Float']['output']
    balloonPaymentSum: Scalars['Float']['output']
    balloonPaymentVatPercentage?: Maybe<Scalars['Float']['output']>
    balloonPaymentWithVat?: Maybe<Scalars['Float']['output']>
    /** The ID of the object on the Beezaar marketplace */
    beezaarObjectId?: Maybe<Scalars['ID']['output']>
    boundaries?: Maybe<LeaseBoundaries>
    category: Category
    children: Array<Lease>
    createdAt: Scalars['DateTime']['output']
    cumulativeMarkUpInterestPercentage?: Maybe<Scalars['Float']['output']>
    currentFairMarketValue?: Maybe<Scalars['Float']['output']>
    customInterestPercentageByIntermediary?: Maybe<Scalars['Float']['output']>
    customTrackAndTraceRequired: Scalars['Boolean']['output']
    deal: Deal
    deliveryVatPercentage?: Maybe<Scalars['Float']['output']>
    /** Aanbetaling */
    downPayment: Scalars['Float']['output']
    downPaymentSum: Scalars['Float']['output']
    downPaymentToUs?: Maybe<Scalars['Float']['output']>
    downPaymentToUsVatPercentage?: Maybe<Scalars['Float']['output']>
    downPaymentToUsWithVat?: Maybe<Scalars['Float']['output']>
    downPaymentToVendor?: Maybe<Scalars['Float']['output']>
    downPaymentToVendorEnabledByExternalUser?: Maybe<
        Scalars['Boolean']['output']
    >
    downPaymentToVendorVatPercentage?: Maybe<Scalars['Float']['output']>
    downPaymentToVendorWithVat?: Maybe<Scalars['Float']['output']>
    downPaymentVatPercentage?: Maybe<Scalars['Float']['output']>
    downPaymentWithVat?: Maybe<Scalars['Float']['output']>
    eifEndDate: Scalars['DateTime']['output']
    eifTrafficLight?: Maybe<EifTrafficLightEnum>
    /** @deprecated Use accountingSystemReference instead */
    externalReference?: Maybe<Scalars['String']['output']>
    /** @deprecated Please use fairMarketValues instead */
    fairMarketValue?: Maybe<Array<Scalars['String']['output']>>
    fairMarketValues?: Maybe<Array<Scalars['String']['output']>>
    firstPayment?: Maybe<Payment>
    /** Behandelingskosten */
    handlingFee: Scalars['Float']['output']
    handlingFeeSum: Scalars['Float']['output']
    handlingFeeVatPercentage: Scalars['Float']['output']
    handlingFeeWithVat: Scalars['Float']['output']
    humanBalloonPayment: Scalars['String']['output']
    humanBalloonPaymentVatPercentage?: Maybe<Scalars['String']['output']>
    humanBalloonPaymentWithVat?: Maybe<Scalars['String']['output']>
    humanCumulativeMarkUpInterestPercentage?: Maybe<Scalars['String']['output']>
    humanDeliveryVatPercentage?: Maybe<Scalars['String']['output']>
    humanDownPayment: Scalars['String']['output']
    humanDownPaymentToUs?: Maybe<Scalars['String']['output']>
    humanDownPaymentToUsVatPercentage?: Maybe<Scalars['String']['output']>
    humanDownPaymentToUsWithVat?: Maybe<Scalars['String']['output']>
    humanDownPaymentToVendor?: Maybe<Scalars['String']['output']>
    humanDownPaymentToVendorVatPercentage?: Maybe<Scalars['String']['output']>
    humanDownPaymentToVendorWithVat?: Maybe<Scalars['String']['output']>
    humanDownPaymentVatPercentage?: Maybe<Scalars['String']['output']>
    humanDownPaymentWithVat?: Maybe<Scalars['String']['output']>
    humanHandlingFee: Scalars['String']['output']
    humanHandlingFeeVatPercentage: Scalars['String']['output']
    humanHandlingFeeWithVat: Scalars['String']['output']
    humanInterestPercentage?: Maybe<Scalars['String']['output']>
    humanInvoicedPaymentToUs?: Maybe<Scalars['String']['output']>
    humanMonthlyBudget?: Maybe<Scalars['String']['output']>
    humanMonthlyPayment: Scalars['String']['output']
    humanMonthlyPaymentVatPercentage?: Maybe<Scalars['String']['output']>
    humanMonthlyPaymentWithVat?: Maybe<Scalars['String']['output']>
    humanMonthlyPaymentWithVatFinancing?: Maybe<Scalars['String']['output']>
    humanPaymentToCustomer?: Maybe<Scalars['String']['output']>
    humanPrincipal: Scalars['String']['output']
    humanPurchaseOption?: Maybe<Scalars['String']['output']>
    humanPurchaseOptionVatPercentage?: Maybe<Scalars['String']['output']>
    humanPurchaseOptionWithVat?: Maybe<Scalars['String']['output']>
    humanPurchasePrice: Scalars['String']['output']
    humanPurchasePriceVatPercentage?: Maybe<Scalars['String']['output']>
    humanPurchasePriceWithVat?: Maybe<Scalars['String']['output']>
    humanPurchasePriceWithoutVehicleTax?: Maybe<Scalars['String']['output']>
    humanPurchasePriceWithoutVehicleTaxWithVat?: Maybe<
        Scalars['String']['output']
    >
    humanServiceVatPercentage?: Maybe<Scalars['String']['output']>
    humanTaxablePrincipal?: Maybe<Scalars['String']['output']>
    humanTradeInToVendor?: Maybe<Scalars['String']['output']>
    humanTradeInToVendorVatPercentage?: Maybe<Scalars['String']['output']>
    humanTradeInToVendorWithVat?: Maybe<Scalars['String']['output']>
    /** @deprecated Use humanDeliveryVatPercentage or humanServiceVatPercentage instead */
    humanVatPercentage?: Maybe<Scalars['String']['output']>
    humanVehiclePurchaseTax?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    interestPercentage?: Maybe<Scalars['Float']['output']>
    /** Fee tussenpersoon */
    intermediaryFee?: Maybe<Scalars['Float']['output']>
    intermediaryFeeEnabledByIntermediary?: Maybe<Scalars['Boolean']['output']>
    intermediaryFeePercentageByIntermediary?: Maybe<Scalars['Float']['output']>
    intermediaryFeeSum?: Maybe<Scalars['Float']['output']>
    /** Bijdrage tussenpersoon */
    intermediaryFixedContribution?: Maybe<Scalars['Float']['output']>
    intermediaryFixedContributionSum: Scalars['Float']['output']
    /** Doelrente tussenpersoon */
    intermediaryTargetInterestPercentage?: Maybe<Scalars['Float']['output']>
    invoicedPaymentToUs?: Maybe<Scalars['Float']['output']>
    invoices: Array<Invoice>
    lastEventAt?: Maybe<Scalars['DateTime']['output']>
    lastImportFromAccountingSystemAt?: Maybe<Scalars['DateTime']['output']>
    latestEndOn?: Maybe<Scalars['Date']['output']>
    lecturaMarketValue?: Maybe<Scalars['Float']['output']>
    marketValue?: Maybe<Scalars['Float']['output']>
    /** Leasebudget */
    monthlyBudget?: Maybe<Scalars['Int']['output']>
    /** Leasetermijn */
    monthlyPayment: Scalars['Float']['output']
    monthlyPaymentSum: Scalars['Float']['output']
    monthlyPaymentVatPercentage?: Maybe<Scalars['Float']['output']>
    monthlyPaymentWithVat?: Maybe<Scalars['Float']['output']>
    monthlyPaymentWithVatFinancing?: Maybe<Scalars['Float']['output']>
    objectAnnualUsage?: Maybe<Scalars['Int']['output']>
    objectAxleConfiguration?: Maybe<Scalars['String']['output']>
    objectBelongings?: Maybe<Scalars['String']['output']>
    objectBrand?: Maybe<Scalars['String']['output']>
    objectChassisNumber?: Maybe<Scalars['String']['output']>
    objectIdentification: Scalars['String']['output']
    objectIdentificationMark?: Maybe<Scalars['String']['output']>
    objectLicensePlateNumber?: Maybe<Scalars['String']['output']>
    objectSerialNumber?: Maybe<Scalars['String']['output']>
    objectTotalUsage?: Maybe<Scalars['Int']['output']>
    objectType?: Maybe<Scalars['String']['output']>
    objectUsed: Scalars['Boolean']['output']
    objectYear: Scalars['Int']['output']
    /** @deprecated Use typeOfFinance instead */
    operational: Scalars['Boolean']['output']
    paidOutAt?: Maybe<Scalars['Date']['output']>
    parent: Lease
    paymentToCustomer?: Maybe<Scalars['Float']['output']>
    payments?: Maybe<Array<Payment>>
    plannedEndOn?: Maybe<Scalars['Date']['output']>
    plannedStartOn?: Maybe<Scalars['Date']['output']>
    plannedStartOnConfirmedByExternalUser?: Maybe<Scalars['Boolean']['output']>
    postCalculationBoundaries?: Maybe<PostCalculationBoundaries>
    /** Leasebedrag */
    principal: Scalars['Float']['output']
    /** Koopoptie */
    purchaseOption?: Maybe<Scalars['Int']['output']>
    purchaseOptionSum: Scalars['Float']['output']
    purchaseOptionVatPercentage?: Maybe<Scalars['Float']['output']>
    purchaseOptionWithVat?: Maybe<Scalars['Float']['output']>
    /** Aanschafwaarde */
    purchasePrice: Scalars['Float']['output']
    purchasePriceSum: Scalars['Float']['output']
    purchasePriceVatPercentage?: Maybe<Scalars['Float']['output']>
    purchasePriceWithVat?: Maybe<Scalars['Float']['output']>
    purchasePriceWithoutVehicleTax?: Maybe<Scalars['Float']['output']>
    purchasePriceWithoutVehicleTaxWithVat?: Maybe<Scalars['Float']['output']>
    quantity: Scalars['Int']['output']
    rdwObjectBrand?: Maybe<Scalars['String']['output']>
    rdwObjectType?: Maybe<Scalars['String']['output']>
    reference: Scalars['String']['output']
    region: Region
    serviceVatPercentage?: Maybe<Scalars['Float']['output']>
    showCumulativeMarkUpPlusIrsPercentage: Scalars['Boolean']['output']
    showInterestPercentage: Scalars['Boolean']['output']
    /** Status Beehive */
    state: LeaseStatesEnum
    taxablePrincipal?: Maybe<Scalars['Float']['output']>
    /** Looptijd */
    tenor: Scalars['Int']['output']
    tradeInToVendor?: Maybe<Scalars['Float']['output']>
    tradeInToVendorEnabledByExternalUser?: Maybe<Scalars['Boolean']['output']>
    tradeInToVendorVatPercentage?: Maybe<Scalars['Float']['output']>
    tradeInToVendorWithVat?: Maybe<Scalars['Float']['output']>
    typeOfFinance: TypeOfFinanceEnum
    updatedAt: Scalars['DateTime']['output']
    vatFinancing: VatFinancing
    /** @deprecated Use deliveryVatPercentage or serviceVatPercentage instead */
    vatPercentage?: Maybe<Scalars['Float']['output']>
    vehiclePurchaseTax?: Maybe<Scalars['Int']['output']>
    vendorOrganization?: Maybe<Organization>
    withRentOut: Scalars['Boolean']['output']
    /**
     * Sale & leaseback
     * @deprecated Use typeOfFinance instead
     */
    withSale: Scalars['Boolean']['output']
}

/** A lease group */
export type LeaseGroupAttachmentsArgs = {
    excludeTopicTypes?: InputMaybe<Array<AttachmentTopicTypeEnum>>
    excludeTypes?: InputMaybe<Array<AttachmentTypeEnum>>
    filterStates?: InputMaybe<Array<AttachmentStateTypeEnum>>
    filterTopicTypes?: InputMaybe<Array<AttachmentTopicTypeEnum>>
    filterTypes?: InputMaybe<Array<AttachmentTypeEnum>>
    providedBefore?: InputMaybe<DealStatesEnum>
    requestedFrom?: InputMaybe<DealStatesEnum>
}

/** A lease group */
export type LeaseGroupInvoicesArgs = {
    filterTypes?: InputMaybe<Array<InvoiceItemTypeEnum>>
}

/** A lease group */
export type LeaseGroupPaymentsArgs = {
    filterStates?: InputMaybe<Array<PaymentStateEnum>>
    filterTypes?: InputMaybe<Array<PaymentTypeEnum>>
}

/** Lease group calculation result */
export type LeaseGroupCalculation = {
    __typename?: 'LeaseGroupCalculation'
    balloonPaymentSum: Scalars['Float']['output']
    dealTrafficLights: DealTrafficLights
    downPaymentSum: Scalars['Float']['output']
    handlingFeeSum: Scalars['Float']['output']
    intermediaryFeeSum: Scalars['Float']['output']
    intermediaryFixedContributionSum: Scalars['Float']['output']
    monthlyPaymentSum: Scalars['Float']['output']
    purchaseOptionSum: Scalars['Float']['output']
    purchasePriceSum: Scalars['Float']['output']
    /** Looptijd */
    tenor: Scalars['Int']['output']
}

/** Lease order fields */
export enum LeaseOrderFieldEnum {
    PaidOutAt = 'paid_out_at',
    Reference = 'reference',
}

/** Lease order type */
export type LeaseOrderInput = {
    direction: DealOrderDirectionEnum
    field: LeaseOrderFieldEnum
}

/** Lease states */
export enum LeaseStatesEnum {
    BoughtOffEarly = 'bought_off_early',
    Cancelled = 'cancelled',
    Completed = 'completed',
    Complied = 'complied',
    CompliedSoft4leaseExported = 'complied_soft4lease_exported',
    ConditionallyCompleted = 'conditionally_completed',
    ContractSent = 'contract_sent',
    Dissolved = 'dissolved',
    DissolvementRequested = 'dissolvement_requested',
    DossierCompleted = 'dossier_completed',
    EarlyBuyoutApproved = 'early_buyout_approved',
    EarlyBuyoutPrepared = 'early_buyout_prepared',
    EarlyBuyoutSent = 'early_buyout_sent',
    LesseeChangePrepared = 'lessee_change_prepared',
    LesseeChanged = 'lessee_changed',
    PaidOff = 'paid_off',
    PayoutPrepared = 'payout_prepared',
    Processing = 'processing',
    Rejected = 'rejected',
    Renewed = 'renewed',
    SignedContractApproved = 'signed_contract_approved',
    SignedContractCompleted = 'signed_contract_completed',
    SignedContractReceived = 'signed_contract_received',
    Soft4leaseExported = 'soft4lease_exported',
}

/** Valid types suggested lease calculations */
export enum LeaseSuggestedTypeEnum {
    EifFl = 'eif_fl',
    HighPurchasePrice = 'high_purchase_price',
    LowPrice = 'low_price',
    LowTenor = 'low_tenor',
    Optimal = 'optimal',
}

export type LeaseSummary = {
    __typename?: 'LeaseSummary'
    externalReference?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    objectBrand: Scalars['String']['output']
    objectType: Scalars['String']['output']
    reference: Scalars['String']['output']
}

/** Abstract class for defining errors as Types */
export type LoginCodeAlreadyUsed = {
    __typename?: 'LoginCodeAlreadyUsed'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

/** Abstract class for defining errors as Types */
export type LoginCodeExpired = {
    __typename?: 'LoginCodeExpired'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

/** Abstract class for defining errors as Types */
export type LoginCodeNotFound = {
    __typename?: 'LoginCodeNotFound'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

export type LoginLinkSent = {
    __typename?: 'LoginLinkSent'
    message?: Maybe<Scalars['String']['output']>
}

export type MarkNotificationReadInput = {
    id: Scalars['ID']['input']
}

export type MarkNotificationReadPayload = {
    __typename?: 'MarkNotificationReadPayload'
    notification: Notification
}

export type MarketingOptions = {
    expectedLeadTimeline?: InputMaybe<Scalars['String']['input']>
    gclId?: InputMaybe<Scalars['String']['input']>
    gtmContainerId?: InputMaybe<Scalars['String']['input']>
    referralLink?: InputMaybe<Scalars['String']['input']>
}

export type Mutation = {
    __typename?: 'Mutation'
    authenticate?: Maybe<AuthenticationUnion>
    confirmSignatoryChoice?: Maybe<ConfirmSignatoryChoicePayload>
    createBankTransactionsUpload?: Maybe<CreateBankTransactionsUploadUnion>
    createCollectionAuthorizationUpload?: Maybe<CreateCollectionAuthorizationUnion>
    /** @deprecated No longer generates a contract. Use attachments with filter instead. */
    createContract?: Maybe<CreateContractPayload>
    createPublicIntermediary?: Maybe<CreatePublicIntermediaryPayload>
    customerCreateDeal?: Maybe<CreateDealPayload>
    customerRequestDeal?: Maybe<CustomerRequestedDeal>
    customerRequestStartedDeal?: Maybe<CustomerRequestStartedDealUnion>
    customerUpdateDeal?: Maybe<UpdateDealPayload>
    customerUpdateLease?: Maybe<UpdateLeasePayload>
    customerUpdateOrganization?: Maybe<UpdateOrganizationPayload>
    deleteAttachment?: Maybe<DeleteAttachmentPayload>
    downloadAnnuitySchedule?: Maybe<DownloadAnnuitySchedulePayload>
    downloadVatAnnuitySchedule?: Maybe<DownloadVatAnnuitySchedulePayload>
    downloadYearlyOverview?: Maybe<DownloadYearlyOverviewPayload>
    findOrCreateIntermediary?: Maybe<FindOrCreateIntermediaryPayload>
    generateCreditInvoiceDocument?: Maybe<GenerateCreditInvoiceDocumentPayload>
    generateSalesInvoiceDocument?: Maybe<GenerateSalesInvoiceDocumentPayload>
    generateUboStatementFormDossier?: Maybe<GenerateUboStatementFormUnion>
    intermediaryAcceptTerms?: Maybe<AcceptTermsPayload>
    intermediaryCancelDeal?: Maybe<CancelDealPayload>
    intermediaryCloneLease?: Maybe<CloneLeasePayload>
    intermediaryCloneLeaseGroup?: Maybe<CloneLeaseGroupPayload>
    intermediaryCommentDeal?: Maybe<IntermediaryCommentDealPayload>
    intermediaryCreateDeal?: Maybe<CreateDealPayload>
    intermediaryCreateIndication?: Maybe<CreateIndicationPayload>
    intermediaryCreateKvoDeal?: Maybe<CreateKvoDealPayload>
    intermediaryCreateLease?: Maybe<CreateLeasePayload>
    intermediaryCreateLeaseGroup?: Maybe<CreateLeaseGroupPayload>
    intermediaryCreateUboStatement?: Maybe<CreateUboStatementPayload>
    intermediaryDeactivateUser?: Maybe<DeactivateUserPayload>
    intermediaryDeleteLease?: Maybe<DeleteLeasePayload>
    intermediaryDeleteLeaseGroup?: Maybe<DeleteLeaseGroupPayload>
    intermediaryRequestDeal?: Maybe<IntermediaryRequestDealPayload>
    intermediaryRequestStartedDeal?: Maybe<IntermediaryRequestStartedDealPayload>
    intermediaryUndoRequestStartedDeal?: Maybe<IntermediaryUndoRequestStartedDealPayload>
    intermediaryUpdateDeal?: Maybe<UpdateDealPayload>
    intermediaryUpdateDealContact?: Maybe<IntermediaryUpdateDealContactPayload>
    intermediaryUpdateIntermediary?: Maybe<UpdateIntermediaryPayload>
    intermediaryUpdateIntermediaryFeePercentageByIntermediary?: Maybe<UpdateIntermediaryFeePercentageByIntermediary>
    intermediaryUpdateLease?: Maybe<UpdateLeasePayload>
    intermediaryUpdateLeaseGroup?: Maybe<UpdateLeaseGroupPayload>
    intermediaryUpdateOrganization?: Maybe<UpdateOrganizationPayload>
    markNotificationRead?: Maybe<MarkNotificationReadPayload>
    notifyDigitalSigning?: Maybe<NotifyDigitalSigningPayload>
    requestAdvice?: Maybe<RequestAdvicePayload>
    requestBankConsent?: Maybe<RequestBankConsentUnion>
    requestVatFinancingEarlyBuyout?: Maybe<RequestVatFinancingEarlyBuyoutPayload>
    requestYearlyOverview?: Maybe<RequestYearlyOverviewPayload>
    revokeBankConsent?: Maybe<RevokeBankConsentUnion>
    sendLoginLink?: Maybe<SendLoginLinkUnion>
    signOut?: Maybe<SignOut>
    toggleNotificationRead?: Maybe<ToggleNotificationReadPayload>
    updateCurrentUser?: Maybe<UpdateCurrentUserPayload>
    updateLastUsedBeeportVersion?: Maybe<UpdateLastUsedBeeportVersionPayload>
    updateLastUsedMyBeequipVersion?: Maybe<UpdateLastUsedMyBeequipVersionPayload>
    updatePlannedStartOn?: Maybe<UpdatePlannedStartOnPayload>
    updateSignatoryChoice?: Maybe<UpdateSignatoryChoicePayload>
    updateUboStatementFormDossier?: Maybe<UpdateUboStatementFormDossierUnion>
    uploadAdditionalAttachment?: Maybe<UploadAdditionalAttachmentPayload>
    uploadAttachment?: Maybe<UploadAttachmentPayload>
    validateUboStatementFormDossier?: Maybe<ValidateUboStatementFormDossierUnion>
}

export type MutationAuthenticateArgs = {
    input?: InputMaybe<AuthenticateInput>
}

export type MutationConfirmSignatoryChoiceArgs = {
    input?: InputMaybe<ConfirmSignatoryChoiceInput>
}

export type MutationCreateBankTransactionsUploadArgs = {
    input?: InputMaybe<CreateBankTransactionsUploadInput>
}

export type MutationCreateCollectionAuthorizationUploadArgs = {
    input?: InputMaybe<CreateCollectionAuthorizationUploadInput>
}

export type MutationCreateContractArgs = {
    input?: InputMaybe<CreateContractInput>
}

export type MutationCreatePublicIntermediaryArgs = {
    input?: InputMaybe<CreatePublicIntermediaryInput>
}

export type MutationCustomerCreateDealArgs = {
    input?: InputMaybe<CreateDealInput>
}

export type MutationCustomerRequestDealArgs = {
    input?: InputMaybe<CustomerRequestDealInput>
}

export type MutationCustomerRequestStartedDealArgs = {
    input?: InputMaybe<CustomerRequestStartedDealInput>
}

export type MutationCustomerUpdateDealArgs = {
    input: UpdateDealInput
}

export type MutationCustomerUpdateLeaseArgs = {
    input: UpdateLeaseInput
}

export type MutationCustomerUpdateOrganizationArgs = {
    input?: InputMaybe<UpdateOrganizationInput>
}

export type MutationDeleteAttachmentArgs = {
    input: DeleteAttachmentInput
}

export type MutationDownloadAnnuityScheduleArgs = {
    input: DownloadAnnuityScheduleInput
}

export type MutationDownloadVatAnnuityScheduleArgs = {
    input: DownloadVatAnnuityScheduleInput
}

export type MutationDownloadYearlyOverviewArgs = {
    input: DownloadYearlyOverviewInput
}

export type MutationFindOrCreateIntermediaryArgs = {
    input?: InputMaybe<FindOrCreateIntermediaryInput>
}

export type MutationGenerateCreditInvoiceDocumentArgs = {
    input: GenerateCreditInvoiceDocumentInput
}

export type MutationGenerateSalesInvoiceDocumentArgs = {
    input: GenerateSalesInvoiceDocumentInput
}

export type MutationGenerateUboStatementFormDossierArgs = {
    input: GenerateUboStatementFormDossierInput
}

export type MutationIntermediaryAcceptTermsArgs = {
    input?: InputMaybe<AcceptTermsInput>
}

export type MutationIntermediaryCancelDealArgs = {
    input?: InputMaybe<CancelDealInput>
}

export type MutationIntermediaryCloneLeaseArgs = {
    leaseId: Scalars['ID']['input']
}

export type MutationIntermediaryCloneLeaseGroupArgs = {
    leaseId: Scalars['ID']['input']
}

export type MutationIntermediaryCommentDealArgs = {
    input?: InputMaybe<IntermediaryCommentDealInput>
}

export type MutationIntermediaryCreateDealArgs = {
    input?: InputMaybe<CreateDealInput>
}

export type MutationIntermediaryCreateIndicationArgs = {
    input?: InputMaybe<CreateIndicationInput>
}

export type MutationIntermediaryCreateKvoDealArgs = {
    input: CreateDealInput
}

export type MutationIntermediaryCreateLeaseArgs = {
    input: CreateLeaseInput
}

export type MutationIntermediaryCreateLeaseGroupArgs = {
    input?: InputMaybe<CreateLeaseGroupInput>
}

export type MutationIntermediaryCreateUboStatementArgs = {
    input?: InputMaybe<CreateUboStatementInput>
}

export type MutationIntermediaryDeleteLeaseArgs = {
    leaseId: Scalars['ID']['input']
}

export type MutationIntermediaryDeleteLeaseGroupArgs = {
    leaseId: Scalars['ID']['input']
}

export type MutationIntermediaryRequestDealArgs = {
    input?: InputMaybe<IntermediaryRequestDealInput>
}

export type MutationIntermediaryRequestStartedDealArgs = {
    input?: InputMaybe<IntermediaryRequestStartedDealInput>
}

export type MutationIntermediaryUndoRequestStartedDealArgs = {
    input?: InputMaybe<IntermediaryUndoRequestStartedDealInput>
}

export type MutationIntermediaryUpdateDealArgs = {
    input: UpdateDealInput
}

export type MutationIntermediaryUpdateDealContactArgs = {
    input?: InputMaybe<IntermediaryUpdateDealContactInput>
}

export type MutationIntermediaryUpdateIntermediaryArgs = {
    input?: InputMaybe<UpdateIntermediaryInput>
}

export type MutationIntermediaryUpdateIntermediaryFeePercentageByIntermediaryArgs =
    {
        input?: InputMaybe<IntermediaryFeePercentageByIntermediaryInput>
    }

export type MutationIntermediaryUpdateLeaseArgs = {
    input: UpdateLeaseInput
}

export type MutationIntermediaryUpdateLeaseGroupArgs = {
    input?: InputMaybe<UpdateLeaseGroupInput>
}

export type MutationIntermediaryUpdateOrganizationArgs = {
    input?: InputMaybe<UpdateOrganizationInput>
}

export type MutationMarkNotificationReadArgs = {
    input: MarkNotificationReadInput
}

export type MutationNotifyDigitalSigningArgs = {
    input?: InputMaybe<NotifyDigitalSigningInput>
}

export type MutationRequestAdviceArgs = {
    input: RequestAdviceInput
}

export type MutationRequestBankConsentArgs = {
    input?: InputMaybe<RequestBankConsentInput>
}

export type MutationRequestVatFinancingEarlyBuyoutArgs = {
    input: RequestVatFinancingEarlyBuyoutInput
}

export type MutationRequestYearlyOverviewArgs = {
    input: RequestYearlyOverviewInput
}

export type MutationRevokeBankConsentArgs = {
    input?: InputMaybe<RevokeBankConsentInput>
}

export type MutationSendLoginLinkArgs = {
    input?: InputMaybe<SendLoginLinkInput>
}

export type MutationSignOutArgs = {
    input?: InputMaybe<SignOutInput>
}

export type MutationToggleNotificationReadArgs = {
    input: ToggleNotificationReadInput
}

export type MutationUpdateCurrentUserArgs = {
    input?: InputMaybe<UpdateUserInput>
}

export type MutationUpdateLastUsedBeeportVersionArgs = {
    input: UpdateLastUsedBeeportVersionInput
}

export type MutationUpdateLastUsedMyBeequipVersionArgs = {
    input: UpdateLastUsedMyBeequipVersionInput
}

export type MutationUpdatePlannedStartOnArgs = {
    input: UpdatePlannedStartOnInput
}

export type MutationUpdateSignatoryChoiceArgs = {
    input: UpdateSignatoryChoiceInput
}

export type MutationUpdateUboStatementFormDossierArgs = {
    input: UpdateUboStatementFormDossierInput
}

export type MutationUploadAdditionalAttachmentArgs = {
    input: UploadAdditionalAttachmentInput
}

export type MutationUploadAttachmentArgs = {
    input: UploadAttachmentInput
}

export type MutationValidateUboStatementFormDossierArgs = {
    input: ValidateUboStatementFormDossierInput
}

/** Notification that is intended for a customer user or intermediary user */
export type Notification = {
    __typename?: 'Notification'
    /** Text containing details of the notification */
    content: Scalars['String']['output']
    /** Timestamp when the notification was created */
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    /** Path that points to the action of the notification */
    linkPath?: Maybe<Scalars['String']['output']>
    /** Small text describing the action of the link of the notification */
    linkTitle?: Maybe<Scalars['String']['output']>
    /** URL that points to the action of the notification */
    linkUrl?: Maybe<Scalars['String']['output']>
    notificationEventType: NotificationEventTypeEnum
    /** Indicates whether notification is considered read */
    read: Scalars['Boolean']['output']
    /** Small text describing the notification */
    title: Scalars['String']['output']
}

/** Preference of the user to receive notifications from this specific notification event */
export type NotificationEventPreference = {
    __typename?: 'NotificationEventPreference'
    /** User receives emails for this notification and notifications from this type of `NotificationEvent` are included when querying the notifications of this user */
    enabled: Scalars['Boolean']['output']
    /** Type of the notification event that triggers the notifications */
    type: NotificationEventTypeEnum
}

/** Valid types for notification events */
export enum NotificationEventTypeEnum {
    AttachmentNewFilesAdded = 'AttachmentNewFilesAdded',
    BankCreditAnalysisDossierCompleted = 'BankCreditAnalysisDossierCompleted',
    BankCreditAnalysisDossierRequested = 'BankCreditAnalysisDossierRequested',
    BankTransactionDossierRequested = 'BankTransactionDossierRequested',
    CollectionMandateGiven = 'CollectionMandateGiven',
    CollectionMandateRequested = 'CollectionMandateRequested',
    ConditionallyCompletedOverdue = 'ConditionallyCompletedOverdue',
    ContractSent = 'ContractSent',
    EarlyBuyoutPaymentPaid = 'EarlyBuyoutPaymentPaid',
    ExternalSourceDealCreated = 'ExternalSourceDealCreated',
    FirstPaymentPaid = 'FirstPaymentPaid',
    FirstPaymentRequested = 'FirstPaymentRequested',
    InactiveBeespecialDealFound = 'InactiveBeespecialDealFound',
    InactiveDealsSpotted = 'InactiveDealsSpotted',
    IncompleteComplianceReminderSent = 'IncompleteComplianceReminderSent',
    InvoiceAttachmentCancelled = 'InvoiceAttachmentCancelled',
    LeasesPaidOut = 'LeasesPaidOut',
    OrganizationCreditChanged = 'OrganizationCreditChanged',
    OrganizationStructureChanged = 'OrganizationStructureChanged',
    QuoteApproved = 'QuoteApproved',
    ReadyForCompleteDossier = 'ReadyForCompleteDossier',
}

export type NotifyDigitalSigningInput = {
    token: Scalars['String']['input']
}

export type NotifyDigitalSigningPayload = {
    __typename?: 'NotifyDigitalSigningPayload'
    token: Scalars['String']['output']
}

export type ObjectBrand = {
    __typename?: 'ObjectBrand'
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
}

export type ObjectType = {
    __typename?: 'ObjectType'
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
}

/** Min and max values for the object year boundary */
export type ObjectYearBoundary = {
    __typename?: 'ObjectYearBoundary'
    /** Maximal object year */
    max: Scalars['Int']['output']
    /** Minimal object year, including potential extra tolerance */
    min: Scalars['Int']['output']
    /** Minimal object year, without potential extra tolerance */
    minWithoutTolerance: Scalars['Int']['output']
}

/** Order types */
export enum OrderEnum {
    NewestFirst = 'newest_first',
    OldestFirst = 'oldest_first',
}

/** An Organization, can be Vendor or Customer */
export type Organization = {
    __typename?: 'Organization'
    address?: Maybe<Scalars['String']['output']>
    bankAccountNumber?: Maybe<Scalars['String']['output']>
    bankCreditAnalysisDossiers?: Maybe<Array<BankCreditAnalysisDossier>>
    bankTransactionDossiers?: Maybe<Array<BankTransactionDossier>>
    city?: Maybe<Scalars['String']['output']>
    cocNumber: Scalars['String']['output']
    collectionMandate?: Maybe<CollectionMandate>
    contacts?: Maybe<Array<Contact>>
    createdAt: Scalars['DateTime']['output']
    customerUsers?: Maybe<Array<User>>
    email?: Maybe<Scalars['String']['output']>
    exemptFromUboStatement: Scalars['Boolean']['output']
    friendlyKind?: Maybe<OrganizationKindEnum>
    humanKind?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    invoiceEmail?: Maybe<Scalars['String']['output']>
    /** @deprecated Deprecated. Use `organizationInvoices` query instead */
    invoices: Array<Invoice>
    kind?: Maybe<Scalars['String']['output']>
    lastImportFromAccountingSystemAt?: Maybe<Scalars['DateTime']['output']>
    name: Scalars['String']['output']
    postalCode?: Maybe<Scalars['String']['output']>
    reference: Scalars['String']['output']
    requireUboStatement: Scalars['Boolean']['output']
    signatories: Array<OrganizationSignatory>
    trafficLight: Scalars['String']['output']
    uboStatementFormDossier?: Maybe<UboStatementFormDossier>
    updatedAt: Scalars['DateTime']['output']
    vatNumber?: Maybe<Scalars['String']['output']>
    yearlyOverviews?: Maybe<Array<YearlyOverview>>
}

/** An Organization, can be Vendor or Customer */
export type OrganizationBankCreditAnalysisDossiersArgs = {
    order?: InputMaybe<OrderEnum>
}

/** An Organization, can be Vendor or Customer */
export type OrganizationBankTransactionDossiersArgs = {
    order?: InputMaybe<OrderEnum>
}

/** An Organization, can be Vendor or Customer */
export type OrganizationContactsArgs = {
    filterInput?: InputMaybe<ContactFilterInput>
    orderInput?: InputMaybe<ContactOrderInput>
}

/** An Organization, can be Vendor or Customer */
export type OrganizationInvoicesArgs = {
    filterTypes?: InputMaybe<Array<InvoiceItemTypeEnum>>
}

/** An Organization, can be Vendor or Customer */
export type OrganizationSignatoriesArgs = {
    person?: InputMaybe<Scalars['Boolean']['input']>
}

/** Abstract class for defining errors as Types */
export type OrganizationAlreadyClaimed = {
    __typename?: 'OrganizationAlreadyClaimed'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

export type OrganizationCollection = {
    __typename?: 'OrganizationCollection'
    /** Aggregations of the OrganizationCollection */
    aggregations: Array<SearchAggregation>
    /** Information about the pagination of the OrganizationCollection */
    pagination: Pagination
    /** Results of the performed search */
    results: Array<Organization>
}

/** Filter options for organization */
export type OrganizationFilterInput = {
    /** Filter deals on given state(s) */
    dealStates?: InputMaybe<Array<DealStatesEnum>>
}

export type OrganizationInvoicesInput = {
    organizationId: Scalars['ID']['input']
}

export type OrganizationInvoicesPayload = {
    __typename?: 'OrganizationInvoicesPayload'
    invoices: Array<InvoiceUnion>
}

export enum OrganizationKindEnum {
    Association = 'association',
    CivilLawPartnershipFirm = 'civil_law_partnership_firm',
    Foundation = 'foundation',
    LimitedCompany = 'limited_company',
    LimitedPartnershipFirm = 'limited_partnership_firm',
    PartnershipFirm = 'partnership_firm',
    PrivateLimitedCompany = 'private_limited_company',
    SoleTraderCompany = 'sole_trader_company',
    Unknown = 'unknown',
}

/** Organization search result */
export type OrganizationSearchResult = {
    __typename?: 'OrganizationSearchResult'
    address?: Maybe<Scalars['String']['output']>
    city?: Maybe<Scalars['String']['output']>
    cocNumber: Scalars['ID']['output']
    name: Scalars['String']['output']
}

export type OrganizationSignatory = {
    __typename?: 'OrganizationSignatory'
    name: Scalars['String']['output']
}

/** Information about pagination in a connection. */
export type PageInfo = {
    __typename?: 'PageInfo'
    /** When paginating forwards, the cursor to continue. */
    endCursor?: Maybe<Scalars['String']['output']>
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean']['output']
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean']['output']
    /** When paginating backwards, the cursor to continue. */
    startCursor?: Maybe<Scalars['String']['output']>
}

export type Pagination = {
    __typename?: 'Pagination'
    /** The index of the current page */
    currentPage: Scalars['Int']['output']
    /** The amount of records on each page */
    perPage: Scalars['Int']['output']
    /** The total number of records in the collection */
    totalCount: Scalars['Int']['output']
    /** The total number of pages */
    totalPages: Scalars['Int']['output']
}

/** Payment details */
export type Payment = {
    __typename?: 'Payment'
    amount: Scalars['Float']['output']
    amountWithVat: Scalars['Float']['output']
    description: Scalars['String']['output']
    humanAmount: Scalars['String']['output']
    humanAmountWithVat: Scalars['String']['output']
    id?: Maybe<Scalars['ID']['output']>
    idealPayments: Array<IdealPayment>
    landingUrl: Scalars['String']['output']
    paymentGroupLandingUrl?: Maybe<Scalars['String']['output']>
    paymentGroupToken?: Maybe<Scalars['String']['output']>
    paymentItems: Array<PaymentItem>
    paymentType: PaymentTypeEnum
    state: PaymentStateEnum
    token: Scalars['String']['output']
}

/** Payment details */
export type PaymentGroup = {
    __typename?: 'PaymentGroup'
    amount: Scalars['Float']['output']
    amountWithVat: Scalars['Float']['output']
    humanAmount: Scalars['String']['output']
    humanAmountWithVat: Scalars['String']['output']
    id: Scalars['ID']['output']
    landingUrl: Scalars['String']['output']
    payments: Array<Payment>
    token: Scalars['String']['output']
}

/** Payment item details */
export type PaymentItem = {
    __typename?: 'PaymentItem'
    amount: Scalars['Float']['output']
    amountWithVat: Scalars['Float']['output']
    humanAmount: Scalars['String']['output']
    humanAmountWithVat: Scalars['String']['output']
    humanItemType: Scalars['String']['output']
    humanVatPercentage: Scalars['String']['output']
    id: Scalars['ID']['output']
    itemType: PaymentItemTypeEnum
    vatPercentage: Scalars['Float']['output']
}

/** Valid types for PaymentItems */
export enum PaymentItemTypeEnum {
    Custom = 'custom',
    DownPayment = 'down_payment',
    EarlyBuyout = 'early_buyout',
    FirstAnnuity = 'first_annuity',
    HandlingFee = 'handling_fee',
    UpfrontVat = 'upfront_vat',
    VatFinancingFee = 'vat_financing_fee',
    VatFinancingFirstAnnuity = 'vat_financing_first_annuity',
}

/** Valid states for payments */
export enum PaymentStateEnum {
    Failed = 'failed',
    New = 'new',
    Paid = 'paid',
    PartiallyPaid = 'partially_paid',
}

/** Valid types for payments */
export enum PaymentTypeEnum {
    Custom = 'custom',
    EarlyBuyout = 'early_buyout',
    Fake = 'fake',
    First = 'first',
}

/** Min and max values for a boundary */
export type PercentageBoundary = {
    __typename?: 'PercentageBoundary'
    /** Maximal value */
    max: Scalars['Float']['output']
    /** Minimal value */
    min: Scalars['Float']['output']
}

export type PossibleSigningPersons = {
    __typename?: 'PossibleSigningPersons'
    party: Scalars['String']['output']
    persons: Array<Scalars['String']['output']>
    /** True when we do not need signatures of a individual person, but ask a signature of the company as a whole */
    signingAsCompany: Scalars['Boolean']['output']
}

/** Calculated lease boundaries */
export type PostCalculationBoundaries = {
    __typename?: 'PostCalculationBoundaries'
    /** Intermediary fixed contribution boundaries */
    customIntermediaryFixedContribution: CurrencyBoundary
    /** Intermediary target interest percentage boundaries */
    customIntermediaryTargetInterestPercentage: PercentageBoundary
}

export type PostCalculationBoundariesInput = {
    /** Amount that the intermediary can contribute to the lease to lower the interest for the customer */
    customIntermediaryFixedContribution?: InputMaybe<
        Scalars['Currency']['input']
    >
    /** Target interest percentage that intermediary can request, by contributing to the lease to compensate for the lower interest rate */
    customIntermediaryTargetInterestPercentage?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Token of the intermediary, used to apply intermediary settings */
    intermediaryToken?: InputMaybe<Scalars['String']['input']>
    /** ID of the lease to base the boundaries on */
    leaseId: Scalars['ID']['input']
    /** Token of the deal, used to scope the leaseId as anonymous user */
    token?: InputMaybe<Scalars['String']['input']>
}

export type PostCalculationBoundariesPayload = {
    __typename?: 'PostCalculationBoundariesPayload'
    postCalculationBoundaries: PostCalculationBoundaries
}

export type PublicIntermediary = {
    __typename?: 'PublicIntermediary'
    cocNumber: Scalars['String']['output']
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    token?: Maybe<Scalars['String']['output']>
}

/** The query root of this schema */
export type Query = {
    __typename?: 'Query'
    attachment?: Maybe<Attachment>
    bankCreditAnalysisDossier?: Maybe<BankCreditAnalysisDossier>
    bankTransactionDossier?: Maybe<BankTransactionDossier>
    calculateLease?: Maybe<CalculateLeasePayload>
    calculateLeaseGroup?: Maybe<CalculateLeaseGroupPayload>
    categoryGroups: Array<CategoryGroup>
    categorySuggestions?: Maybe<CategorySuggestionsPayload>
    collectionMandate?: Maybe<CollectionMandate>
    countries?: Maybe<Array<Country>>
    deal?: Maybe<Deal>
    dealIdentificationRequest?: Maybe<DealIdentificationRequest>
    deals?: Maybe<DealCollection>
    dealsSummary: DealsSummaryConnection
    /** Find a lease by id */
    lease?: Maybe<Lease>
    leaseBoundaries?: Maybe<LeaseBoundariesPayload>
    leases?: Maybe<LeaseCollection>
    notifications: Array<Notification>
    objectBrandSearch: Array<ObjectBrand>
    objectTypeSearch: Array<ObjectType>
    /** Find an organization by ID */
    organization?: Maybe<Organization>
    organizationInvoices?: Maybe<OrganizationInvoicesPayload>
    /** Search organization by CoC number or name */
    organizationSearch: Array<OrganizationSearchResult>
    organizations?: Maybe<OrganizationCollection>
    payment?: Maybe<Payment>
    paymentGroup?: Maybe<PaymentGroup>
    postCalculationBoundaries?: Maybe<PostCalculationBoundariesPayload>
    uboStatementFormDossier?: Maybe<UboStatementFormDossier>
    /** The current user */
    user?: Maybe<UserUnion>
}

/** The query root of this schema */
export type QueryAttachmentArgs = {
    id?: InputMaybe<Scalars['ID']['input']>
    token?: InputMaybe<Scalars['String']['input']>
}

/** The query root of this schema */
export type QueryBankCreditAnalysisDossierArgs = {
    token: Scalars['String']['input']
}

/** The query root of this schema */
export type QueryBankTransactionDossierArgs = {
    token: Scalars['String']['input']
}

/** The query root of this schema */
export type QueryCalculateLeaseArgs = {
    input: CalculateLeaseInput
}

/** The query root of this schema */
export type QueryCalculateLeaseGroupArgs = {
    input: CalculateLeaseGroupInput
}

/** The query root of this schema */
export type QueryCategorySuggestionsArgs = {
    input: CategorySuggestionsInput
}

/** The query root of this schema */
export type QueryCollectionMandateArgs = {
    token: Scalars['String']['input']
}

/** The query root of this schema */
export type QueryDealArgs = {
    id?: InputMaybe<Scalars['ID']['input']>
    token?: InputMaybe<Scalars['String']['input']>
}

/** The query root of this schema */
export type QueryDealIdentificationRequestArgs = {
    token: Scalars['String']['input']
}

/** The query root of this schema */
export type QueryDealsArgs = {
    aggregationFilter?: InputMaybe<DealAggregationFilterInput>
    filter?: InputMaybe<DealFilterInput>
    order?: InputMaybe<DealOrderInput>
    page?: InputMaybe<Scalars['Int']['input']>
    perPage?: InputMaybe<Scalars['Int']['input']>
    searchQuery?: InputMaybe<Scalars['String']['input']>
}

/** The query root of this schema */
export type QueryDealsSummaryArgs = {
    after?: InputMaybe<Scalars['String']['input']>
    before?: InputMaybe<Scalars['String']['input']>
    first?: InputMaybe<Scalars['Int']['input']>
    last?: InputMaybe<Scalars['Int']['input']>
}

/** The query root of this schema */
export type QueryLeaseArgs = {
    id: Scalars['ID']['input']
}

/** The query root of this schema */
export type QueryLeaseBoundariesArgs = {
    input: LeaseBoundariesInput
}

/** The query root of this schema */
export type QueryLeasesArgs = {
    filter?: InputMaybe<LeaseFilterInput>
    order?: InputMaybe<LeaseOrderInput>
    page?: InputMaybe<Scalars['Int']['input']>
    perPage?: InputMaybe<Scalars['Int']['input']>
}

/** The query root of this schema */
export type QueryObjectBrandSearchArgs = {
    query: Scalars['String']['input']
}

/** The query root of this schema */
export type QueryObjectTypeSearchArgs = {
    brand: Scalars['String']['input']
    query: Scalars['String']['input']
}

/** The query root of this schema */
export type QueryOrganizationArgs = {
    id: Scalars['ID']['input']
}

/** The query root of this schema */
export type QueryOrganizationInvoicesArgs = {
    input: OrganizationInvoicesInput
}

/** The query root of this schema */
export type QueryOrganizationSearchArgs = {
    query: Scalars['String']['input']
}

/** The query root of this schema */
export type QueryOrganizationsArgs = {
    filter?: InputMaybe<OrganizationFilterInput>
    page?: InputMaybe<Scalars['Int']['input']>
    perPage?: InputMaybe<Scalars['Int']['input']>
}

/** The query root of this schema */
export type QueryPaymentArgs = {
    token: Scalars['String']['input']
}

/** The query root of this schema */
export type QueryPaymentGroupArgs = {
    token: Scalars['String']['input']
}

/** The query root of this schema */
export type QueryPostCalculationBoundariesArgs = {
    input: PostCalculationBoundariesInput
}

/** The query root of this schema */
export type QueryUboStatementFormDossierArgs = {
    token: Scalars['String']['input']
}

/** A region */
export type Region = {
    __typename?: 'Region'
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    legalAreaOfUseDescription?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    updatedAt: Scalars['DateTime']['output']
}

export type RequestAdviceInput = {
    comments?: InputMaybe<Scalars['String']['input']>
    contactPersonEmail?: InputMaybe<Scalars['String']['input']>
    contactPersonName?: InputMaybe<Scalars['String']['input']>
    contactPersonPhone?: InputMaybe<Scalars['String']['input']>
    token: Scalars['String']['input']
}

export type RequestAdvicePayload = {
    __typename?: 'RequestAdvicePayload'
    errors?: Maybe<Array<AttributeError>>
    event?: Maybe<Event>
}

export type RequestBankConsentInput = {
    acceptedBankTransactionUsage: Scalars['Boolean']['input']
    bankBic: Scalars['String']['input']
    specifiedBankAccountNumber?: InputMaybe<Scalars['String']['input']>
    token: Scalars['String']['input']
}

/** Response after requesting bank consent */
export type RequestBankConsentUnion =
    | BankConsentProviderError
    | BankConsentSuccess
    | ValidationError

export type RequestVatFinancingEarlyBuyoutInput = {
    dealId: Scalars['ID']['input']
    leaseIds: Array<Scalars['ID']['input']>
}

export type RequestVatFinancingEarlyBuyoutPayload = {
    __typename?: 'RequestVatFinancingEarlyBuyoutPayload'
    errors?: Maybe<Array<AttributeError>>
    event?: Maybe<Event>
}

export type RequestYearlyOverviewInput = {
    organizationId: Scalars['ID']['input']
    year: Scalars['Int']['input']
}

/** Response after requesting yearly overview */
export type RequestYearlyOverviewPayload = {
    __typename?: 'RequestYearlyOverviewPayload'
    errors?: Maybe<Array<AttributeError>>
    event?: Maybe<Event>
}

export type RevokeBankConsentInput = {
    token: Scalars['String']['input']
}

/** Response after revoking bank consent */
export type RevokeBankConsentUnion =
    | BankConsentProviderError
    | BankConsentSuccess

export type SalesInvoice = {
    __typename?: 'SalesInvoice'
    activatedOn: Scalars['Date']['output']
    creditInvoice: CreditInvoice
    documentAllowed: Scalars['Boolean']['output']
    dueOn: Scalars['Date']['output']
    humanActivatedOn: Scalars['String']['output']
    humanDueOn: Scalars['String']['output']
    humanTotalAmount: Scalars['String']['output']
    humanTotalAmountWithVat?: Maybe<Scalars['String']['output']>
    humanTotalVatAmount?: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    invoiceType: SalesInvoiceTypesEnum
    reference: Scalars['String']['output']
    salesInvoiceItems: Array<SalesInvoiceItem>
    totalAmount: Scalars['Float']['output']
    totalAmountWithVat?: Maybe<Scalars['Float']['output']>
    totalVatAmount?: Maybe<Scalars['Float']['output']>
}

export type SalesInvoiceItem = {
    __typename?: 'SalesInvoiceItem'
    amount: Scalars['Float']['output']
    amountWithVat?: Maybe<Scalars['Float']['output']>
    humanAmount: Scalars['String']['output']
    humanAmountWithVat?: Maybe<Scalars['String']['output']>
}

export enum SalesInvoiceTypesEnum {
    Activation = 'activation',
    EarlyBuyout = 'early_buyout',
    IncreasedFirstAnnuity = 'increased_first_annuity',
    MonthlyAnnuityTerm = 'monthly_annuity_term',
    Renewal = 'renewal',
    Unknown = 'unknown',
    UpfrontVat = 'upfront_vat',
}

export type SearchAggregation = {
    __typename?: 'SearchAggregation'
    buckets?: Maybe<Array<AggregationBucket>>
    field: Scalars['String']['output']
}

export type SendLoginLinkInput = {
    dealToken?: InputMaybe<Scalars['String']['input']>
    email: Scalars['String']['input']
    path?: InputMaybe<Scalars['String']['input']>
    userType: UserTypeEnum
}

/** Response for send login link request */
export type SendLoginLinkUnion = LoginLinkSent | UserInactive | UserNotFound

/** Abstract class for defining errors as Types */
export type SessionScopeNotFound = {
    __typename?: 'SessionScopeNotFound'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

export type SignOut = {
    __typename?: 'SignOut'
    /** Indicates what type was used to persist the authentication of the user */
    persistenceType: GraphqlAuthenticationPersistenceTypeEnum
    /** Indicates which session scope was used to notify about the persisted authentication in the cookies */
    sessionScope?: Maybe<GraphqlAuthenticationSessionScopeEnum>
    /** Indicates whether sign out was completed */
    success: Scalars['Boolean']['output']
}

/** Arguments to terminate the persisted authentication */
export type SignOutInput = {
    persistenceType: GraphqlAuthenticationPersistenceTypeEnum
}

/** A Signatory */
export type Signatory = {
    __typename?: 'Signatory'
    city: Scalars['String']['output']
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    organizations: Array<Scalars['String']['output']>
    /**
     * Url to start signing. When coming from a signing dossier add the param ?deal_token={deal_token} to
     *                                       the url to get redirected back to the correct deal &attachment_id={attachment_id} is also allowed
     *                                       and will be added to the return url
     */
    signUrl: Scalars['String']['output']
    signedAt?: Maybe<Scalars['DateTime']['output']>
    state: Scalars['String']['output']
    usingDeprecatedSigning: Scalars['Boolean']['output']
}

/** Signatory authorization enum */
export enum SignatoryAuthorizationTypeEnum {
    Independent = 'independent',
    Joint = 'joint',
    Limited = 'limited',
    None = 'none',
    Unknown = 'unknown',
}

/** Deal signatory selection */
export type SignatorySelection = {
    __typename?: 'SignatorySelection'
    confirmationRequired: Scalars['Boolean']['output']
    enoughSignatoriesSelected: Scalars['Boolean']['output']
    requiredPersonIds: Array<Scalars['ID']['output']>
    selectedPersonIds: Array<Scalars['ID']['output']>
    signingParties: Array<SigningParty>
}

/** Deal signing details */
export type SigningDossier = {
    __typename?: 'SigningDossier'
    id?: Maybe<Scalars['ID']['output']>
    name: Scalars['String']['output']
    /** can be used to download the document */
    originalAttachments?: Maybe<Array<Attachment>>
    /** When a contract is being signed by a company instead of a person. This can be used to show witch persons are allowed to sign */
    possibleSigningPersons?: Maybe<Array<PossibleSigningPersons>>
    /** Final signatories with the digital sign links */
    signatories: Array<Signatory>
    signatorySelection?: Maybe<SignatorySelection>
    signatorySelectionAllowed: Scalars['Boolean']['output']
    /** can be used to upload the documents */
    signedAttachments?: Maybe<Array<Attachment>>
    state: DealSigningStateEnum
    /** token for updating and finalizing the signing persons */
    token?: Maybe<Scalars['String']['output']>
    type: DealSigningTypeEnum
}

export type SigningParty = {
    __typename?: 'SigningParty'
    /** When false it can be hidden from the user as he does not have to choose */
    choiceRequired: Scalars['Boolean']['output']
    confirmationRequired: Scalars['Boolean']['output']
    enoughSignatoriesSelected: Scalars['Boolean']['output']
    humanRole: Scalars['String']['output']
    name: Scalars['String']['output']
    role: SigningPartyRolesEnum
    signatories: Array<SigningPartySignatory>
    /** True when we do not need the signatures of individual persons, but as a signature of the company as a whole */
    signingAsCompany: Scalars['Boolean']['output']
}

export enum SigningPartyRolesEnum {
    DonorLessee = 'donor_lessee',
    Guarantor = 'guarantor',
    Lessee = 'lessee',
    Surety = 'surety',
    Unknown = 'unknown',
}

export type SigningPartySignatory = {
    __typename?: 'SigningPartySignatory'
    authorizationStrength: SignatoryAuthorizationTypeEnum
    humanAuthorizationStrength: Scalars['String']['output']
    name: Scalars['String']['output']
    /** On behalf of which companies is this person authorized to sign */
    organizations: Array<Scalars['String']['output']>
    personId: Scalars['ID']['output']
}

/** Support bank details */
export type SupportedBank = {
    __typename?: 'SupportedBank'
    bic: Scalars['String']['output']
    name: Scalars['String']['output']
    requiresBankAccountNumber: Scalars['Boolean']['output']
    supportedContentTypes: Array<Scalars['String']['output']>
    /** @deprecated Replaced by supportedExtensions field */
    supportedExtension?: Maybe<Scalars['String']['output']>
    supportedExtensions: Array<Scalars['String']['output']>
    uploadSupported: Scalars['Boolean']['output']
}

export type ToggleNotificationReadInput = {
    id: Scalars['ID']['input']
}

export type ToggleNotificationReadPayload = {
    __typename?: 'ToggleNotificationReadPayload'
    notification: Notification
}

/** Valid types of finance for a lease */
export enum TypeOfFinanceEnum {
    Financial = 'financial',
    Mortgage = 'mortgage',
    Operational = 'operational',
    SaleAndFinancialLeaseback = 'sale_and_financial_leaseback',
    SaleAndMortgageLeaseback = 'sale_and_mortgage_leaseback',
    SaleAndOperationalLeaseback = 'sale_and_operational_leaseback',
}

export type UboStatementFormDossier = {
    __typename?: 'UboStatementFormDossier'
    id?: Maybe<Scalars['ID']['output']>
    kind?: Maybe<UboStatementFormDossierKindEnum>
    numberOfShareholders?: Maybe<Scalars['Int']['output']>
    organization: Organization
    people: Array<UboStatementFormDossierPerson>
    signingDossier?: Maybe<SigningDossier>
    state: UboStatementFormDossierStateEnum
    token: Scalars['String']['output']
}

export enum UboStatementFormDossierKindEnum {
    PseudoUbo = 'pseudo_ubo',
    Ubo = 'ubo',
}

export type UboStatementFormDossierPerson = {
    __typename?: 'UboStatementFormDossierPerson'
    address?: Maybe<Scalars['String']['output']>
    city?: Maybe<Scalars['String']['output']>
    country?: Maybe<Country>
    dateOfBirth?: Maybe<Scalars['String']['output']>
    firstName?: Maybe<Scalars['String']['output']>
    functionTitle?: Maybe<Scalars['String']['output']>
    id?: Maybe<Scalars['ID']['output']>
    lastName?: Maybe<Scalars['String']['output']>
    nationality?: Maybe<Country>
    number?: Maybe<Scalars['Int']['output']>
    postalCode?: Maybe<Scalars['String']['output']>
    sharesPercentage?: Maybe<Scalars['Float']['output']>
    votingRightsPercentage?: Maybe<Scalars['Float']['output']>
}

export enum UboStatementFormDossierStateEnum {
    Generated = 'generated',
    Open = 'open',
    Validated = 'validated',
}

export type UpdateCurrentUserPayload = {
    __typename?: 'UpdateCurrentUserPayload'
    user?: Maybe<UserUnion>
}

/** Properties for updating a deal */
export type UpdateDealInput = {
    cocNumber?: InputMaybe<Scalars['String']['input']>
    comments?: InputMaybe<Scalars['String']['input']>
    id?: InputMaybe<Scalars['ID']['input']>
    marketingOptions?: InputMaybe<MarketingOptions>
    token?: InputMaybe<Scalars['String']['input']>
}

export type UpdateDealPayload = {
    __typename?: 'UpdateDealPayload'
    deal?: Maybe<Deal>
    errors?: Maybe<Array<AttributeError>>
}

export type UpdateIntermediaryFeePercentageByIntermediary = {
    __typename?: 'UpdateIntermediaryFeePercentageByIntermediary'
    deal?: Maybe<Deal>
}

/** Properties for updating an intermediary */
export type UpdateIntermediaryInput = {
    logo?: InputMaybe<Scalars['Upload']['input']>
    showLogo?: InputMaybe<Scalars['Boolean']['input']>
    vendorObjectBrand?: InputMaybe<Scalars['String']['input']>
}

export type UpdateIntermediaryPayload = {
    __typename?: 'UpdateIntermediaryPayload'
    intermediary?: Maybe<Intermediary>
}

/** Properties for updating the last used Beeport version of a user */
export type UpdateLastUsedBeeportVersionInput = {
    /** The semantic version number of the Beeport application that should be stored in the user profile, e.g. "2.5.1" */
    lastUsedBeeportVersion: Scalars['String']['input']
}

export type UpdateLastUsedBeeportVersionPayload = {
    __typename?: 'UpdateLastUsedBeeportVersionPayload'
    user?: Maybe<IntermediaryUser>
}

/** Properties for updating the last used My Beequip version of a user */
export type UpdateLastUsedMyBeequipVersionInput = {
    /** The semantic version number of the My Beequip application that should be stored in the user profile, e.g. "2.5.1" */
    lastUsedMyBeequipVersion: Scalars['String']['input']
}

export type UpdateLastUsedMyBeequipVersionPayload = {
    __typename?: 'UpdateLastUsedMyBeequipVersionPayload'
    user?: Maybe<CustomerUser>
}

/** Properties for updating a lease group */
export type UpdateLeaseGroupInput = {
    /** Specifies the advertisement url */
    advertisingUrl?: InputMaybe<Scalars['String']['input']>
    /** Amount that customer pays when transferring ownership of object, optional when using monthlyBudget */
    balloonPayment?: InputMaybe<Scalars['Currency']['input']>
    /** ID of the category to which the object belongs */
    categoryId?: InputMaybe<Scalars['ID']['input']>
    /** Specifies the custom interest percentage the intermediary wants to use for this deal */
    customInterestPercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Specifies the fixed contribution the intermediary wants to make, to use intermediary contribution for this deal */
    customIntermediaryFixedContribution?: InputMaybe<
        Scalars['Currency']['input']
    >
    /** Specifies the target interest percentage the intermediary wants to use for this deal, when using intermediary contribution */
    customIntermediaryTargetInterestPercentage?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Specifies whether object has a track and trace system */
    customTrackAndTraceRequired?: InputMaybe<Scalars['Boolean']['input']>
    /** Amount that customer pays up-front when the object is bought, optional when using monthlyBudget */
    downPayment?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer pays up-front to the vender when the object is bought. */
    downPaymentToVendor?: InputMaybe<Scalars['Currency']['input']>
    /** Indicates if the external user enabled the down payment to vendor */
    downPaymentToVendorEnabledByExternalUser?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies whether intermediary wants to receive a fee */
    intermediaryFeeEnabledByIntermediary?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies the desired fee as percentage of object for intermediary */
    intermediaryFeePercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** ID of the lease to update */
    leaseId: Scalars['ID']['input']
    /** Amount that the object is worth, purchasePrice is used as default, can be overwritten with good reason */
    marketValue?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer is willing to pay per month for object, will be used to calculate purchasePrice */
    monthlyBudget?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies the estimated amount of kilometers or hours that object will be used every year */
    objectAnnualUsage?: InputMaybe<Scalars['Int']['input']>
    /** Axle configuration for the object */
    objectAxleConfiguration?: InputMaybe<Scalars['String']['input']>
    /** Belongings and attachments of the object */
    objectBelongings?: InputMaybe<Scalars['String']['input']>
    /** Brand of the object */
    objectBrand?: InputMaybe<Scalars['String']['input']>
    /** License plate number of the object */
    objectLicensePlateNumber?: InputMaybe<Scalars['String']['input']>
    /** Specifies amount of kilometers or hours that object has used */
    objectTotalUsage?: InputMaybe<Scalars['Int']['input']>
    /** Type of the object */
    objectType?: InputMaybe<Scalars['String']['input']>
    /** Specifies whether object is new or used */
    objectUsed?: InputMaybe<Scalars['Boolean']['input']>
    /** Construction date of the object */
    objectYear?: InputMaybe<Scalars['Int']['input']>
    /** Specifies when the planned date when the lease will start */
    plannedStartOn?: InputMaybe<Scalars['Date']['input']>
    /** Specifies if the planned start date is confirmed by the external user */
    plannedStartOnConfirmedByExternalUser?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Amount that customer could pay to transfer ownership of object, only applicable with operational leases, optional when using monthlyBudget */
    purchaseOption?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the object will be bought for, optional when using monthlyBudget */
    purchasePrice?: InputMaybe<Scalars['Currency']['input']>
    /** Amount of objects */
    quantity: Scalars['Int']['input']
    /** Tenor of the lease in months, optional when using monthlyBudget */
    tenor?: InputMaybe<Scalars['Int']['input']>
    /** Token of the deal, used to scope the leaseId as anonymous user */
    token?: InputMaybe<Scalars['String']['input']>
    /** Value of the object traded in at the vendor. */
    tradeInToVendor?: InputMaybe<Scalars['Currency']['input']>
    /** Indicates if the external user enabled the trade in to vendor amount */
    tradeInToVendorEnabledByExternalUser?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies the type of financing, preferred argument over use operational or withSale arguments */
    typeOfFinance?: InputMaybe<TypeOfFinanceEnum>
    /** Specifies whether up-front VAT should be financed in a short-term loan */
    vatFinancingEnabled?: InputMaybe<Scalars['Boolean']['input']>
    /** Amount that the customer pays in vehicle tax. The amount is deducted from the purchase price for VAT calculations. (Dutch: bpm) */
    vehiclePurchaseTax?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies the vendor by CoC-number where the object will be bought */
    vendorOrganizationCoc?: InputMaybe<Scalars['String']['input']>
    /** Specifies whether object will be rented out to others */
    withRentOut?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateLeaseGroupPayload = {
    __typename?: 'UpdateLeaseGroupPayload'
    errors?: Maybe<Array<AttributeError>>
    leaseGroup?: Maybe<LeaseGroup>
}

/**
 * These are the arguments for updating a lease.
 *
 * We perform partial updates, so this means that not all arguments
 * are required. You only need to specify the changes.
 *
 * When you update a lease we always need to know which lease
 * you want to update. You can do this in two ways:
 *   1. By specifying the leaseId, this is mostly used by intermediaries and customers
 *   2. By specifying the token of the deal and the leaseId, this is mostly used by anonymous users
 *
 */
export type UpdateLeaseInput = {
    /** Specifies the advertisement url */
    advertisingUrl?: InputMaybe<Scalars['String']['input']>
    /** Amount that customer pays when transferring ownership of object, optional when using monthlyBudget */
    balloonPayment?: InputMaybe<Scalars['Currency']['input']>
    /** ID of the category to which the object belongs */
    categoryId?: InputMaybe<Scalars['ID']['input']>
    /** Specifies the custom interest percentage the intermediary wants to use for this deal */
    customInterestPercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Specifies the fixed contribution the intermediary wants to make, to use intermediary contribution for this deal */
    customIntermediaryFixedContribution?: InputMaybe<
        Scalars['Currency']['input']
    >
    /** Specifies the target interest percentage the intermediary wants to use for this deal, when using intermediary contribution */
    customIntermediaryTargetInterestPercentage?: InputMaybe<
        Scalars['Float']['input']
    >
    /** Specifies whether object has a track and trace system */
    customTrackAndTraceRequired?: InputMaybe<Scalars['Boolean']['input']>
    /** Amount that customer pays up-front when the object is bought, optional when using monthlyBudget */
    downPayment?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer pays up-front to the vender when the object is bought. */
    downPaymentToVendor?: InputMaybe<Scalars['Currency']['input']>
    /** Indicates if the external user enabled the down payment to vendor */
    downPaymentToVendorEnabledByExternalUser?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies whether intermediary wants to receive a fee */
    intermediaryFeeEnabledByIntermediary?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies the desired fee as percentage of object for intermediary */
    intermediaryFeePercentageByIntermediary?: InputMaybe<
        Scalars['Float']['input']
    >
    /** ID of the lease to update */
    leaseId: Scalars['ID']['input']
    /** Amount that the object is worth, purchasePrice is used as default, can be overwritten with good reason */
    marketValue?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the customer is willing to pay per month for object, will be used to calculate purchasePrice */
    monthlyBudget?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies the estimated amount of kilometers or hours that object will be used every year */
    objectAnnualUsage?: InputMaybe<Scalars['Int']['input']>
    /** Axle configuration for the object */
    objectAxleConfiguration?: InputMaybe<Scalars['String']['input']>
    /** Belongings and attachments of the object */
    objectBelongings?: InputMaybe<Scalars['String']['input']>
    /** Brand of the object */
    objectBrand?: InputMaybe<Scalars['String']['input']>
    /** License plate number of the object */
    objectLicensePlateNumber?: InputMaybe<Scalars['String']['input']>
    /** Specifies amount of kilometers or hours that object has used */
    objectTotalUsage?: InputMaybe<Scalars['Int']['input']>
    /** Type of the object */
    objectType?: InputMaybe<Scalars['String']['input']>
    /** Specifies whether object is new or used */
    objectUsed?: InputMaybe<Scalars['Boolean']['input']>
    /** Construction date of the object */
    objectYear?: InputMaybe<Scalars['Int']['input']>
    /** Specifies when the planned date when the lease will start */
    plannedStartOn?: InputMaybe<Scalars['Date']['input']>
    /** Specifies if the planned start date is confirmed by the external user */
    plannedStartOnConfirmedByExternalUser?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Amount that customer could pay to transfer ownership of object, only applicable with operational leases, optional when using monthlyBudget */
    purchaseOption?: InputMaybe<Scalars['Currency']['input']>
    /** Amount that the object will be bought for, optional when using monthlyBudget */
    purchasePrice?: InputMaybe<Scalars['Currency']['input']>
    /** Tenor of the lease in months, optional when using monthlyBudget */
    tenor?: InputMaybe<Scalars['Int']['input']>
    /** Token of the deal, used to scope the leaseId as anonymous user */
    token?: InputMaybe<Scalars['String']['input']>
    /** Value of the object traded in at the vendor. */
    tradeInToVendor?: InputMaybe<Scalars['Currency']['input']>
    /** Indicates if the external user enabled the trade in to vendor amount */
    tradeInToVendorEnabledByExternalUser?: InputMaybe<
        Scalars['Boolean']['input']
    >
    /** Specifies the type of financing, preferred argument over use operational or withSale arguments */
    typeOfFinance?: InputMaybe<TypeOfFinanceEnum>
    /** Specifies whether up-front VAT should be financed in a short-term loan */
    vatFinancingEnabled?: InputMaybe<Scalars['Boolean']['input']>
    /** Amount that the customer pays in vehicle tax. The amount is deducted from the purchase price for VAT calculations. (Dutch: bpm) */
    vehiclePurchaseTax?: InputMaybe<Scalars['Currency']['input']>
    /** Specifies the vendor by CoC-number where the object will be bought */
    vendorOrganizationCoc?: InputMaybe<Scalars['String']['input']>
    /** Specifies whether object will be rented out to others */
    withRentOut?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateLeasePayload = {
    __typename?: 'UpdateLeasePayload'
    boundaries?: Maybe<LeaseBoundaries>
    errors?: Maybe<Array<AttributeError>>
    lease?: Maybe<Lease>
    postCalculationBoundaries: PostCalculationBoundaries
}

/** Properties for updating an organization */
export type UpdateOrganizationInput = {
    customRequireUboStatement?: InputMaybe<Scalars['Boolean']['input']>
    id: Scalars['ID']['input']
    invoiceEmail?: InputMaybe<Scalars['String']['input']>
}

export type UpdateOrganizationPayload = {
    __typename?: 'UpdateOrganizationPayload'
    organization: Organization
}

export type UpdatePlannedStartOnInput = {
    dealId: Scalars['ID']['input']
    leases: Array<UpdatePlannedStartOnLeaseInput>
}

export type UpdatePlannedStartOnLeaseInput = {
    id: Scalars['ID']['input']
    plannedStartOn: Scalars['Date']['input']
    plannedStartOnConfirmedByExternalUser: Scalars['Boolean']['input']
}

export type UpdatePlannedStartOnPayload = {
    __typename?: 'UpdatePlannedStartOnPayload'
    errors?: Maybe<Array<AttributeError>>
    leases?: Maybe<Array<Lease>>
}

export type UpdateSignatoryChoiceInput = {
    signingPersonIds: Array<Scalars['ID']['input']>
    token: Scalars['String']['input']
}

export type UpdateSignatoryChoicePayload = {
    __typename?: 'UpdateSignatoryChoicePayload'
    signingDossier?: Maybe<SigningDossier>
}

export type UpdateUboStatementFormDossierInput = {
    kind?: InputMaybe<UboStatementFormDossierKindEnum>
    numberOfShareholders?: InputMaybe<Scalars['Int']['input']>
    people?: InputMaybe<Array<UpdateUboStatementFormPersonInput>>
    token: Scalars['String']['input']
}

export type UpdateUboStatementFormDossierSuccess = {
    __typename?: 'UpdateUboStatementFormDossierSuccess'
    uboStatementFormDossier: UboStatementFormDossier
}

export type UpdateUboStatementFormDossierUnion =
    | UpdateUboStatementFormDossierSuccess
    | ValidationError

export type UpdateUboStatementFormPersonInput = {
    address?: InputMaybe<Scalars['String']['input']>
    city?: InputMaybe<Scalars['String']['input']>
    country?: InputMaybe<CountryCodeEnum>
    dateOfBirth?: InputMaybe<Scalars['String']['input']>
    firstName?: InputMaybe<Scalars['String']['input']>
    functionTitle?: InputMaybe<Scalars['String']['input']>
    id?: InputMaybe<Scalars['ID']['input']>
    lastName?: InputMaybe<Scalars['String']['input']>
    nationality?: InputMaybe<CountryCodeEnum>
    number?: InputMaybe<Scalars['Int']['input']>
    postalCode?: InputMaybe<Scalars['String']['input']>
    sharesPercentage?: InputMaybe<Scalars['Float']['input']>
    votingRightsPercentage?: InputMaybe<Scalars['Float']['input']>
}

/** Properties for updating a user */
export type UpdateUserInput = {
    disableNotificationEvents?: InputMaybe<Array<NotificationEventTypeEnum>>
    enableNotificationEvents?: InputMaybe<Array<NotificationEventTypeEnum>>
    name: Scalars['String']['input']
    phone: Scalars['String']['input']
    receiveNotifications?: InputMaybe<Scalars['Boolean']['input']>
}

/** Properties for uploading files to an additional attachment */
export type UploadAdditionalAttachmentInput = {
    files: Array<Scalars['Upload']['input']>
    name?: InputMaybe<Scalars['String']['input']>
    source: UploadAttachmentSourceEnum
    /** Authentication token of a Deal */
    token: Scalars['String']['input']
}

export type UploadAdditionalAttachmentPayload = {
    __typename?: 'UploadAdditionalAttachmentPayload'
    attachment?: Maybe<Attachment>
}

/** Properties for uploading files to an attachment */
export type UploadAttachmentInput = {
    files: Array<Scalars['Upload']['input']>
    source: UploadAttachmentSourceEnum
    /** Authentication token of an Attachment */
    token: Scalars['String']['input']
}

export type UploadAttachmentPayload = {
    __typename?: 'UploadAttachmentPayload'
    attachment?: Maybe<Attachment>
}

/** Valid sources for uploading an attachment */
export enum UploadAttachmentSourceEnum {
    Beeport = 'beeport',
    My = 'my',
}

export type User = {
    __typename?: 'User'
    createdAt: Scalars['DateTime']['output']
    email: Scalars['String']['output']
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    notificationPreferences: Array<NotificationEventPreference>
    phone: Scalars['String']['output']
    receiveNotifications: Scalars['Boolean']['output']
    updatedAt: Scalars['DateTime']['output']
}

/** Abstract class for defining errors as Types */
export type UserInactive = {
    __typename?: 'UserInactive'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

/** Abstract class for defining errors as Types */
export type UserNotFound = {
    __typename?: 'UserNotFound'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

/** Types of user in the schema */
export enum UserTypeEnum {
    Customer = 'customer',
    Intermediary = 'intermediary',
}

/** Abstract class for defining errors as Types */
export type UserUnconfirmed = {
    __typename?: 'UserUnconfirmed'
    errorReference: Scalars['String']['output']
    message?: Maybe<Scalars['String']['output']>
}

/** Different types of users */
export type UserUnion = CustomerUser | IntermediaryUser

export type ValidateUboStatementFormDossierInput = {
    token: Scalars['String']['input']
}

export type ValidateUboStatementFormDossierSuccessResponse = {
    __typename?: 'ValidateUboStatementFormDossierSuccessResponse'
    uboStatementFormDossier: UboStatementFormDossier
}

export type ValidateUboStatementFormDossierUnion =
    | ValidateUboStatementFormDossierSuccessResponse
    | ValidationError

/** Contains the validation errors of the object you were trying to manipulate */
export type ValidationError = {
    __typename?: 'ValidationError'
    errorReference: Scalars['String']['output']
    errors: Array<AttributeError>
    message?: Maybe<Scalars['String']['output']>
}

export type VatFinancing = {
    __typename?: 'VatFinancing'
    actualTerms?: Maybe<Array<AnnuityTerm>>
    enabled: Scalars['Boolean']['output']
    handlingFee: Scalars['Float']['output']
    handlingFeeVatPercentage: Scalars['Float']['output']
    handlingFeeWithVat: Scalars['Float']['output']
    humanHandlingFee: Scalars['String']['output']
    humanHandlingFeeVatPercentage: Scalars['String']['output']
    humanHandlingFeeWithVat: Scalars['String']['output']
    humanInterestPercentage?: Maybe<Scalars['String']['output']>
    humanMonthlyPayment?: Maybe<Scalars['String']['output']>
    humanPrincipal: Scalars['String']['output']
    interestPercentage?: Maybe<Scalars['Float']['output']>
    monthlyPayment?: Maybe<Scalars['Float']['output']>
    principal: Scalars['Float']['output']
    tenor: Scalars['Int']['output']
    tenorEqualToLeaseTenor: Scalars['Boolean']['output']
    terms?: Maybe<Array<AnnuityTerm>>
}

/** Min and max values for a year or month boundary */
export type YearMonthBoundary = {
    __typename?: 'YearMonthBoundary'
    /** Maximal value */
    max: Scalars['Int']['output']
    /** Minimal value */
    min: Scalars['Int']['output']
}

export type YearlyOverview = {
    __typename?: 'YearlyOverview'
    canDownload?: Maybe<Scalars['Boolean']['output']>
    requestedAtFinance?: Maybe<Scalars['Boolean']['output']>
    year?: Maybe<Scalars['Int']['output']>
}

export type CalculationQueryVariables = Exact<{
    input: CalculateLeaseInput
}>

export type CalculationQuery = {
    __typename?: 'Query'
    calculateLease?: {
        __typename?: 'CalculateLeasePayload'
        calculation?: {
            __typename?: 'LeaseCalculation'
            monthlyPayment: number
        } | null
        boundaries?: {
            __typename?: 'LeaseBoundaries'
            acceptable: boolean
            downPayment: {
                __typename?: 'CurrencyBoundary'
                min: number
                max: number
            }
            tenor: {
                __typename?: 'YearMonthBoundary'
                min: number
                max: number
            }
        } | null
        errors?: Array<{
            __typename?: 'AttributeError'
            attribute: string
            message: string
        }> | null
    } | null
}

export type CategoriesQueryVariables = Exact<{ [key: string]: never }>

export type CategoriesQuery = {
    __typename?: 'Query'
    categoryGroups: Array<{
        __typename?: 'CategoryGroup'
        id: string
        name: string
        categories: Array<{
            __typename?: 'Category'
            id: string
            name: string
            defaultForCategoryGroup: boolean
            supportedTypesOfFinance: Array<string>
        }>
    }>
}

export const CalculationDocument = `
    query Calculation($input: CalculateLeaseInput!) {
  calculateLease(input: $input) {
    calculation {
      monthlyPayment
    }
    boundaries {
      acceptable
      downPayment {
        min
        max
      }
      tenor {
        min
        max
      }
    }
    errors {
      attribute
      message
    }
  }
}
    `
export const CategoriesDocument = `
    query Categories {
  categoryGroups {
    id
    name
    categories {
      id
      name
      defaultForCategoryGroup
      supportedTypesOfFinance
    }
  }
}
    `
export type Requester<C = {}> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R> | AsyncIterable<R>
export function getSdk<C>(requester: Requester<C>) {
    return {
        Calculation(
            variables: CalculationQueryVariables,
            options?: C
        ): Promise<CalculationQuery> {
            return requester<CalculationQuery, CalculationQueryVariables>(
                CalculationDocument,
                variables,
                options
            ) as Promise<CalculationQuery>
        },
        Categories(
            variables?: CategoriesQueryVariables,
            options?: C
        ): Promise<CategoriesQuery> {
            return requester<CategoriesQuery, CategoriesQueryVariables>(
                CategoriesDocument,
                variables,
                options
            ) as Promise<CategoriesQuery>
        },
    }
}
export type Sdk = ReturnType<typeof getSdk>
